// EditAssetPageNew

import PropTypes from "prop-types";
import {
  FaFile,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaDownload,
  FaClipboardList,
  FaTools,
  FaListUl,
  FaPaperclip,
} from "react-icons/fa";

import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import InputField from "../../SharedComponent/Fields/InputField";
import TextAreaField from "../../SharedComponent/Fields/TextareaField";
import SelectField from "../../SharedComponent/Fields/SelectField";
import Button from "../../SharedComponent/Button/Button";
import { API_END_POINTS } from "../../network/apiEndPoint";
import {
  deleteProtected,
  deleteProtectedAttachments,
  getProtected,
  patchProtected,
  postProtected,
} from "../../network/ApiService";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Stepper from "./Stepper/Stepper";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { normalizeYearOfManufacture } from "../../utils/yearOfManufacture";
import { showApiErrorToasts } from "../../utils/apiErrorUtils";
import { ImagePlus, Trash2, Upload, X } from "lucide-react";
import { getAttachmentLargeUrl, getAttachmentThumbUrl, getAttachmentDocumentUrl } from "../../utils/attachmentImages";
import HeroSection from "../HeroSection/HeroSection";
import { baseURL } from "../../network/baseUrl";
import BookValueHistory from "./BookValueHistory";
import ContractHistoryTable from "../ContractHistoryTable";
import Batteries from "../assets_type/Batteries";
import Chargers from "../assets_type/Chargers";
import Attachments from "../assets_type/Attachments";
import FinancialInfoSection from "../assets_type/FinancialInfoSection";
import ContractInfoSection from "../assets_type/ContractInfoSection";
import LiftMasts from "../assets_type/LiftMasts";
import WorkPlatforms from "../assets_type/WorkPlateform";
import CleaningEquipment from "../assets_type/CleaningEquipments";
import SpareParts from "../assets_type/SpareParts";
import ConstructionMachinery from "../assets_type/ConstructionMachinery";

const initialAssets = {
  documents: [],
  platform: "",
  visible: true,
  insertDate: "",
  id: null,
  machineIdDealer: "",
  idUrl: "",
  manufacturer: "",
  type: "",
  yearOfManufacture: "",
  operatingHours: "",
  machineSerialNo: "",
  classification: "",
  forkliftClass: "",
  antriebsart: "",
  machineDescriptionTitle: "",
  machineDescriptionSubtitle: "",
  machineDescriptionTemp: "",
  machineAvailable: true,
  truckLocation: "",
  salesmen: [],
  priceType: "",
  techCondition: "",
  reconditioningDate: "",
  offerNoDealer: "",
  offerNoPlatform: "",
  machineLength: "",
  machineWidth: "",
  machineHeight: "",
  basketLoad: "",
  reachHorizontal: "",
  machineWeight: "",
  closedHeight: "",
  freeHeight: "",
  forkCarriage: "",
  forkLength: "",
  loadCentre: "",
  tiresFront: "",
  tiresFront_size: "",
  tiresRear: "",
  tiresRear_size: "",
  twinTires: false,
  addEquipment: [],
  mediaFiles: [],
};

const engineTypeOptions = [
  "Electric",
  "Diesel",
  "LPG",
  "manual/none",
  "Gasoline",
  "Natural gas (CNG)",
  "Hybrid",
  "Li-Ion",
  "Fuel-Cell",
];

const mastTypes = [
  { value: 0, type: "none" },
  { value: 1, type: "standard" },
  { value: 2, type: "mono" },
  { value: 3, type: "duplex" },
  { value: 5, type: "triplex" },
  { value: 8, type: "quattro" },
  { value: 9, type: "telescopic" },
];
const latestInitialAssets = {
  // Truck basic fields
  asset_type: "Forklifts",
  platform: "",
  visible: "",
  manufacturer: "",
  intern_no: "",
  additional_equipment: [],
  year_of_manufacture: "",
  operating_hours: "",
  serial_no: "",
  capacity: "",
  mast_type: 0,
  lift_height_mm: "",
  status: "",
  classification: "",
  fem_class: "",
  engine_type: engineTypeOptions[0],
  condition: "",
  title: "",
  description: "",
  description_temp: "",
  available: false,
  location: "",
  salesmen: "",
  currency: "",
  price: "",
  price_netto: "",
  // dealer_price: "",
  price_description: "",
  rental_price_per_day: "",
  rental_price_per_week: "",
  rental_price_per_month: "",
  rental_price_description: "",
  // dealer_id:"",
  // detail_url:"",

  // Truck Description fields

  type: "",
  // media_files:[],
  // price_usd:"",
  // price_netto_usd:"",
  // rental_price_per_day:"",
  // rental_price:"",
  technical_condition: "",
  optical_condition: "",
  machine_length_mm: "",
  machine_width_mm: "",
  machine_height_mm: "",
  machine_weight_kg: "",
  basket_load: "",
  reach_horizontal: "",
  reconditioning_date: "",
  battery: false,
  battery_voltage: "",
  batterycapacity: "",
  battery_case: "",
  battery_category: "",
  battery_charger: true,
  battery_charger_type: "",
  offer_no_dealer: "",
  offer_no_platform: "",
  closed_height_mm: "",
  freihub: false,
  fork_carr: "",
  free_height: "",
  fork_length: "",
  forks: "",
  load_centre: 0,
  tire_type: "",
  front_tire_size: "",
  rear_tires: "",
  rear_tire_size: "",
  front_tires: "",
  transport_order_url: "",

  working_height: "",
  battery_additional_equipment: "",
  // Dealer Information

  dealer_name: "",
  dealer_status: "",
  dealer_contact_information: "",
  dealer_location: "",
  dealer_price: "",
  dealer_price_netto: "",
  dealer_country: "",
  dealer_city: "",
  dealer_zip: "",
  dealer_street: "",
  dealer_contact_person: "",
  dealer_address: "",
  dealer_phone: "",
  dealer_website: "",
  dealer_email: "",

  // Finance Information
  finance_partner: "",
  financial_contract_classification: "",
  financial_contract: "",
  financial_contract_no: "",
  upload_financial_contract: "",
  financial_contract_start: "",
  financial_contract_end: "",
  duration_in_months: "",
  purchase_price: "",
  acquisition_date: "",
  residual_value_end_of_contract: "",
  book_value: "",
  depreciation_value: "",
  acquisition_costs: "",
  depreciation_method: "",
  next_depreciation: "",
  cost_refurbishing: "",
  transportation_cost: "",
  customer_name: "",
  customer_no: "",
  customer_contract: "",
  upload_customer_contract: null,
  end_of_contract: null,
  contract_completed: false,

  // battery information
  battery_manufacturer: "",
  battery_type: "",
  batterymodel: "",
  battery_voltage: "",
  batterycapacity: "",
  batteryACVoltage: "",
  battery_yom: "",
  batteryAdditionalEquipment: "",
  batterylength: "",
  batterywidth: "",
  batteryweight: "",
  batteryCasing: "",
  battery_location: "",
  battery_description: "",
  battery_length: "",
  battery_height: "",
  additional_equipment_description: "",

  //charger specifications

  chargerManufacturer: "",
  chargerLoadertype: "",
  chargerModel: "",
  chargerAC: "",
  chargerCurrent: "",
  chargerVoltage: "",
  charger_yom: "",
  chargerAdditionalEquipment: "",
  chargerLocation: "",

  mast_description: "",

  forks_description: "",
  tire_description: "",
  fork_carriage_description: "",

  // second tab fields
  end_user_price: "",
  internal_price: "",
  intranet_price: "",
  dealer_price: "",
  rental_price_daily: "",
  rental_price_weekly: "",
  rental_price_monthly: "",
  internal_remark: "",
  intranet_remark: "",
  purchase_price: "",
  purchase_date: "",
  book_value: "",

  // 3rd tab fields
  customer_name: "",
  customer_company_name: "",
  customer_phone: "",
  customer_no: "",
  contract_type: "",
  contract_price_euro: "",
  contract_start: "",
  contract_end: "",
  customer_location_zip: "",
  customer_location_city: "",
  customer_location_country: "",
  customer_contact_name: "",
  customer_email: "",
  customer_number: "",
  invoice_address_street: "",
  invoice_address_zip: "",
  invoice_address_city: "",
  invoice_address_country: "",

  contracts: [
    {
      customer: {
        name: "",
        phone_number: "",
        email: "",
        customer_company: "",
        customer_number: "",
      },
      contract_type: "",
      contract_start: "",
      contract_end: "",
      contract_price_euro: "",
      invoice_address_street: "",
      invoice_address_zip: "",
      invoice_address_city: "",
      invoice_address_country: "",
      delivery_address_street: "",
      delivery_address_zip: "",
      delivery_address_city: "",
      delivery_address_country: "",
    },
  ],
};

const getFileInfo = (url) => {
  const extension = url.split(".").pop().toLowerCase();
  const fileTypes = {
    pdf: {
      type: "application/pdf",
      icon: <FaFilePdf size={20} className="text-danger" />,
    },
    xlsx: {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      icon: <FaFileExcel size={20} className="text-success" />,
    },
    xls: {
      type: "application/vnd.ms-excel",
      icon: <FaFileExcel size={20} className="text-success" />,
    },
    doc: {
      type: "application/msword",
      icon: <FaFileWord size={20} className="text-primary" />,
    },
    docx: {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      icon: <FaFileWord size={20} className="text-primary" />,
    },
  };
  return (
    fileTypes[extension] || {
      type: "application/octet-stream",
      icon: <FaFile size={20} />,
    }
  );
};

const handleDownload = async (url, filename) => {
  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) throw new Error("Download failed");

    const blob = await response.blob();
    const fileInfo = getFileInfo(url);
    const blobWithType = new Blob([blob], { type: fileInfo.type });

    const downloadUrl = window.URL.createObjectURL(blobWithType);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename || url.split("/").pop();
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download error:", error);
    toast.error("Failed to download file");
  }
};

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const formattedDate = date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
  });
  return formattedDate;
};
const AttachmentLink = ({ url, children }) => {
  const filename = url.split("/").pop();
  const fileInfo = getFileInfo(url);
  const [clickTimeout, setClickTimeout] = useState(null);

  const handleClick = (e) => {
    e.preventDefault();

    if (clickTimeout === null) {
      setClickTimeout(
        setTimeout(() => {
          window.open(url, "_blank");
          setClickTimeout(null);
        }, 300)
      );
    } else {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
      handleDownload(url, filename);
    }
  };

  useEffect(() => {
    return () => {
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
    };
  }, [clickTimeout]);

  return (
    <div
      className="attachment-item d-flex align-items-center p-2 border rounded mb-2"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      title={`Click to view, double click to download ${filename}`}
    >
      <div className="file-icon me-2">{fileInfo.icon}</div>
      <span className="file-name flex-grow-1">{filename}</span>
      <small className="text-muted me-2">
        <em>Click to view, double click to download</em>
      </small>
    </div>
  );
};

// Add these options to the top of the file with other constants
const TIRE_OPTIONS = [
  "Cushion",
  "Pneumatic",
  "Polyurethane",
  "Solid Rubber",
  "Super Elastic",
];

const CONDITION_OPTIONS = [
  "New",
  "Like New",
  "Very Good",
  "Good",
  "Normal",
  "Bad",
  "Very Bad",
];

const ATTACHMENT_OPTIONS = [
  "Side Shifter",
  "Double Clamp",
  "Double Side Shifter",
  "Rotator",
  "Triple Clamp",
  "Triple Side Shifter",
  "Drum Clamp",
  "Fork Extension",
  "Clamp Fork",
  "Load Guard",
  "Push Fork",
  "Bulk Material Bucket",
  "Load Pin",
  "Fork Positioner",
  "Double Pallet Clamp",
  "Fork Pallet Coupler",
];

const ADD_EQUIPMENT_OPTIONS = [
  "3rd valve",
  "4th valve",
  "Spotlight rear",
  "Spotlight front",
  "Overhead Guard",
  "Front pane",
  "Weatherproof cover",
  "Heater",
  "Load guard grill",
  "Solenoid valve",
  "Oil separator",
  "Diesel Particle Filter",
  "Road traffic regulation",
  "Weatherproof cabin",
  "Explosion-proof",
  "Pulse control",
  "Initial stroke",
  "Air-condition",
  "Full free-lift",
  "CE certificate",
  "Special Trucks",
  "Stainless Steel",
  "Cold Store",
  "Scales",
  "Twin Tires",
  "Safety Light",
  "Safety Pilot",
  "Non-marking Tires",
  "Lithium-Ion technology",
  "Double-deck loading",
  "Self-driving",
  "Rear view mirror",
  "Side mirror(s)",
  "Joystick",
  "Beacon light",
  "Wipers",
  "Single pedal",
  "Heated seat",
  "LED",
  "Deep Reach",
  "Wire Guidance",
  "Galvanized",
  "3-wheel",
  "Seat",
];

const EditAssetPageNew = ({ show, onClose }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const assetData = location.state?.assetData;
  const { id } = useParams();
  // const [newAsset, setNewAsset] = useState(assetData || { ...initialAssets });
  const [newAsset, setNewAsset] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [showMediaUpload, setShowMediaUpload] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [price, setPrice] = useState("");
  const [currency, setCurrency] = useState("USD");
  const [nettoPrice, setNettoPrice] = useState("");
  const [nettoCurrency, setNettoCurrency] = useState("Netto_euro");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [customPlatform, setCustomPlatform] = useState("");
  const [selectedVisibleOption, setSelectedVisibleOption] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const [machineAvailable, setMachineAvailable] = useState("");
  const [loadCentre, setLoadCentre] = useState(0);
  const [selectedAttachment, setSelectedAttachment] = useState("");
  const [customAttachment, setCustomAttachment] = useState("");
  const [customEquipment, setCustomEquipment] = useState("");
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [isBatteryAvailable, setIsBatteryAvailable] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(new DataTransfer().files);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedContractWarehouse, setSelectedContractWarehouse] =
    useState(null);
  const [warehouseLocationId, setWarehouseLocationId] = useState("");
  const [refreshContracts, setRefreshContracts] = useState(false);
  const navigate = useNavigate();

  const [checboxValue, setCheckboxValue] = useState(false);
  // const [refreshEditPage  , setRefreshEditPage] = useState(false) ;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [assetAttachments, setAssetAttachments] = useState([]);
  const [isLoadingEditPage, setIsLoadingEditPage] = useState(false);
  const [contractForm, setContractForm] = useState({
    customer: {
      name: "",
      email: "",
      phone_number: "",
      address: "",
      customer_manager: 1,
      customer_company: "",
      customer_number: "",
    },
    contract_type: "",
    status: "active", // or initial status
    contract_start: "",
    contract_end: "",
    contract_price_euro: "",
    asset: id,
    invoice_address_street: "",
    invoice_address_city: "",
    invoice_address_country: "",
    invoice_address_zip: "",
    delivery_address_street: "",
    delivery_address_zip: "",
    delivery_address_city: "",
    delivery_address_country: "",
  });

  const getEquipmentKey = (item) =>
    item
      ?.toLowerCase()
      .replace(/\(s\)/g, "s") // Replace (s) with s
      .replace(/[\s\-()]/g, "_") // Replace spaces, hyphens, parentheses with _
      .replace(/_+/g, "_") // Collapse multiple underscores
      .replace(/^_+|_+$/g, ""); // Trim leading/trailing underscores

  const initialContractForm = {
    customer: {
      name: "",
      email: "",
      phone_number: "",
      address: "",
      customer_manager: 1,
      customer_company: "",
      customer_number: "",
    },
    contract_type: "",
    status: "active", // or initial status
    contract_start: "",
    contract_end: "",
    contract_price_euro: "",
    asset: id,
    invoice_address_street: "",
    invoice_address_city: "",
    invoice_address_country: "",
    invoice_address_zip: "",
    delivery_address_street: "",
    delivery_address_zip: "",
    delivery_address_city: "",
    delivery_address_country: "",
  };

  const handleCheckboxToggle = (e) => {
    const isChecked = e.target.checked;
    setCheckboxValue(isChecked);

    if (isChecked) {
      setContractForm((prev) => ({
        ...prev,
        delivery_address_street: prev.invoice_address_street || "",
        delivery_address_city: prev.invoice_address_city || "",
        delivery_address_zip: prev.invoice_address_zip || "",
        delivery_address_country: prev.invoice_address_country || "",
      }));
    }
  };

  const handleContractChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldValue = type === "checkbox" ? checked : value;

    if (
      [
        "name",
        "email",
        "phone_number",
        "address",
        "customer_company",
        "customer_number",
      ].includes(name)
    ) {
      setContractForm((prev) => ({
        ...prev,
        customer: {
          ...prev.customer,
          [name]: fieldValue,
        },
      }));
    } else {
      setContractForm((prev) => ({
        ...prev,
        [name]: fieldValue,
      }));
    }
  };

  const formatAttachment = (attachment) => {
    console.log("attachment = ", attachment);

    const fileName = attachment.split("/").pop();
    console.log("filename = ", fileName);
    return fileName;
  };
  const handleDeleteAttachment = async (attachmentId) => {
    console.log("attachment id = ", attachmentId);
    const token = localStorage.getItem("access");

    const payload = JSON.stringify({ attachment_ids: [attachmentId] });
    try {
      const url = `${baseURL}/assets/${id}/attachments/`;
      const response = await axios.delete(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          attachment_ids: [attachmentId],
        },
      });
      console.log("response from delete api ", response);

      const newAttachments = assetAttachments.filter(
        (attachment) => attachment?.id != attachmentId
      );
      setAssetAttachments(newAttachments);

      toast.success(t("dashboardToasters.attachmentDeleteSuccess"));
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }

      toast.error(t("dashboardToasters.genricError"));
      console.error("Upload failed", error.response?.data || error.message);
    }
  };
  // attachment_ids = [1]  assetid

  function isValidContractPeriod(contract_start, contract_end) {
    const startDate = new Date(contract_start);
    const endDate = new Date(contract_end);
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return false;
    }

    return startDate < endDate;
  }

  const handleCreateContract = async () => {
    if (!contractForm.contract_start || !contractForm.contract_end) return;
    if (isNaN(Number(contractForm.delivery_address_zip))) {
      toast.warn(t("dashboardToasters.zipCodeInteger"));
      return;
    }

    if (isNaN(Number(contractForm.invoice_address_zip))) {
      toast.warn(t("dashboardToasters.zipCodeInteger"));
      return;
    }

    if (
      !isValidContractPeriod(
        contractForm.contract_start,
        contractForm.contract_end
      )
    ) {
      toast.warn(t("dashboardToasters.contractDateValidation"));
      return;
    }
    try {
      const url = `${baseURL}/contract-create/`;
      if (!url) {
        throw new Error("API endpoint not defined");
      }
      setIsLoading(true);
      const response = await postProtected(url, contractForm, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("response of create contract  = ", response);
      setContractForm(initialContractForm);
      setCheckboxValue(false);
      setSelectedContractWarehouse(null);

      toast.success(t("dashboardToasters.contractCreationSuccess"));
    } catch (error) {
      setIsLoading(false);
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      } else if (error.response?.status === 409) {
        toast.warn(t("dashboardToasters.overlapingDatesForContract"));
        return;
      }
      toast.error(t("dashboardToasters.genricError"));
    } finally {
      setIsLoading(false);
      setRefreshContracts((prev) => !prev);
      navigate("/dashboard");
    }
  };

  const categories = [
    { value: "Forklifts", option: t("assets.categories.forklifts") },
    { value: "Batteries", option: t("assets.categories.batteries") },
    { value: "Chargers", option: t("assets.categories.chargers") },
    { value: "Attachments", option: t("assets.categories.attachments") },
    { value: "Lift Masts", option: t("assets.categories.lift_masts") },
    { value: "Work Platforms", option: t("assets.categories.work_platforms") },
    {
      value: "Cleaning Equipment",
      option: t("assets.categories.cleaning_equipment"),
    },
    { value: "Spare Parts", option: t("assets.categories.spare_parts") },
    {
      value: "Construction Machinery",
      option: t("assets.categories.construction_machinery"),
    },
  ];

  const warehouseFieldsSyncedRef = useRef(false);

  const getWarehouseAddressFields = (warehouse, assetData = {}) => ({
    warehouse: warehouse?.id ?? null,
    dealer_street: warehouse?.warehouse_street || assetData.dealer_street || "",
    dealer_city: warehouse?.warehouse_city || assetData.dealer_city || "",
    dealer_zip:
      warehouse?.warehouse_zip != null && warehouse?.warehouse_zip !== ""
        ? warehouse.warehouse_zip
        : assetData.dealer_zip ?? "",
    dealer_country:
      warehouse?.warehouse_country || assetData.dealer_country || "",
  });

  const findWarehouseById = (warehouseList, warehouseId) =>
    warehouseList?.find((warehouse) => String(warehouse?.id) === String(warehouseId));

  const applyWarehouseToAssetState = (warehouseList, warehouseId, assetData) => {
    const warehouse = findWarehouseById(warehouseList, warehouseId);
    if (!warehouse) {
      return assetData;
    }

    setSelectedWarehouse(warehouse);
    setWarehouseLocationId(warehouse.id);
    return {
      ...assetData,
      ...getWarehouseAddressFields(warehouse, assetData),
    };
  };

  const getWarehouses = async () => {
    try {
      const url = API_END_POINTS.warehouses;
      if (!url) {
        throw new Error("API endpoint not defined");
      }
      const response = await getProtected(url);
      console.log("response = ", response);
      if (Array.isArray(response) && response?.length > 0) {
        console.log("setting warehouses = ", response);
        setWarehouses(response);
        return response;
      }
      return [];
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return [];
      }
      toast.error(t("dashboardToasters.genricError"));
      return [];
    }
  };

  const handleWarehouseChange = (e) => {
    console.log("value == ", e.target.value);
    const warehouseId = e.target.value;
    console.log("warehouses = ", warehouses);
    const selectedWarehousee = findWarehouseById(warehouses, warehouseId);
    console.log("selected warehouse = ", selectedWarehousee);

    if (selectedWarehousee) {
      setSelectedWarehouse(selectedWarehousee);
      setWarehouseLocationId(warehouseId);
      setNewAsset((prev) => ({
        ...prev,
        ...getWarehouseAddressFields(selectedWarehousee, prev),
      }));
    } else {
      setSelectedWarehouse(null);
      setWarehouseLocationId(null);
      setNewAsset((prev) => ({
        ...prev,
        warehouse: null,
        dealer_street: "",
        dealer_city: "",
        dealer_zip: "",
        dealer_country: "",
      }));
    }
  };

  const handleWarehouseChange2 = (e) => {
    const warehouseId = e.target.value;
    const selectedWarehousee = warehouses.find(
      (warehouse) => String(warehouse?.id) === warehouseId
    );
    console.log("selected warehouse = ", selectedWarehousee);

    if (selectedWarehousee) {
      setSelectedContractWarehouse(selectedWarehousee);
      setContractForm((prev) => ({
        ...prev,
        invoice_address_street: selectedWarehousee?.warehouse_street || "",
        invoice_address_city: selectedWarehousee?.warehouse_city || "",
        invoice_address_zip: selectedWarehousee?.warehouse_zip || "",
        invoice_address_country: selectedWarehousee?.warehouse_country || "",
        // delivery_address_street: selectedWarehousee?.warehouse_street || "",
        // delivery_address_city: selectedWarehousee?.warehouse_city || "",
        // delivery_address_zip: selectedWarehousee?.warehouse_zip || "",
        // delivery_address_country: selectedWarehousee?.warehouse_country || "",
      }));
    } else {
      setSelectedContractWarehouse(null);
      checboxValue
        ? setContractForm((prev) => ({
            ...prev,
            invoice_address_street: "",
            invoice_address_city: "",
            invoice_address_zip: "",
            invoice_address_country: "",
            delivery_address_street: "",
            delivery_address_city: "",
            delivery_address_zip: "",
            delivery_address_country: "",
          }))
        : setContractForm((prev) => ({
            ...prev,
            invoice_address_street: "",
            invoice_address_city: "",
            invoice_address_zip: "",
            invoice_address_country: "",
          }));

      setCheckboxValue(false);
    }
  };

  const [selectedCategory, setSelectedCategory] = useState("Forklifts");

  const [selectedEngineType, setSelectedEngineType] = useState(
    engineTypeOptions[0]
  );
  const loadCentreOptions = [
    t("assets.options.horizontal_reach"),
    t("assets.options.basket_load"),
  ];
  const [selectedLoadCenter, setSelectedLoadCentre] = useState(
    loadCentreOptions[0]
  );

  const [selectedType, setSelectedType] = useState(0);

  const [isBatteryChargerAvailable, setIsBatteryChargerAvailable] =
    useState(false);
  const transportUrl = newAsset?.transport_order_url?.trim();
  const isValidUrl = (url) => {
    if (!url) return false;
    try {
      // Allow missing protocol by attempting to prepend https
      // if URL has no scheme but looks like a domain/path.
      new URL(url);
      return true;
    } catch {
      try {
        new URL(`https://${url}`);
        return true;
      } catch {
        return false;
      }
    }
  };
  const normalizedTransportUrl = (() => {
    if (!transportUrl) return "";
    try {
      // Keep as-is if already valid
      new URL(transportUrl);
      return transportUrl;
    } catch {
      // Fallback to https prefix
      return `https://${transportUrl}`;
    }
  })();
  const handleCopyTransportUrl = async () => {
    if (!transportUrl) return;
    try {
      await navigator.clipboard.writeText(transportUrl);
      toast.success("Copied transport URL to clipboard");
    } catch {
      toast.info(transportUrl);
    }
  };

  const steps = [
    { title: t("steps.assetBasicInformation"), icon: <FaClipboardList /> },
    {
      title: t("steps.assetFinancialInformation"),
      icon: <FaPaperclip />,
    },
    {
      title: t("steps.contractInformation"),
      icon: <FaListUl />,
    },
  ];

  const toggleEdit = () => {
    setIsEditing(true);
  };

  const handleChange = (e) => {
    if (currentStep === 2) {
      console.log("contract info tab ...... ");
      const name = e.target.name;
      const value = e.target.value;

      if (e.target.type === "checkbox") {
        setCheckboxValue(e.target.checked);
      }

      if (
        name === "name" ||
        name === "email" ||
        name === "phone_number" ||
        name === "customer_number" ||
        name === "customer_company"
      ) {
        setNewAsset((prev) => {
          const updatedContract = [...(prev.contracts || [])];
          const firstContract = updatedContract[0] || {};

          updatedContract[0] = {
            ...firstContract,
            customer: {
              ...firstContract.customer,
              [name]: value,
            },
          };

          return {
            ...prev,
            contracts: updatedContract,
          };
        });
      } else {
        setNewAsset((prev) => {
          const updatedContract = [...(prev.contracts || [])];
          const firstContract = updatedContract[0] || {};

          updatedContract[0] = {
            ...firstContract,
            [name]: value,
          };

          return {
            ...prev,
            contracts: updatedContract,
          };
        });
      }
      console.log("name = ", name);
      return;
    }

    const { name, value, type, files } = e.target;
    console.log("Dealer Id : ", e.target);

    if (type === "file") {
      const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === "file") {
          if (files && files.length > 0) {
            const fileArray = Array.from(files);
            const maxFileSize = 10 * 1024 * 1024; // 10MB
            const validFileTypes = {
              "image/jpeg": "image",
              "image/png": "image",
              "image/gif": "image",
              "application/pdf": "document",
              "application/msword": "document",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                "document",
              "application/vnd.ms-excel": "document",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                "document",
            };

            const validFiles = fileArray.filter((file) => {
              if (!validFileTypes[file.type]) {
                toast.error(t("dashboardToasters.invalidFile"));
                return false;
              }

              if (file.size > maxFileSize) {
                toast.error(t("dashboardToasters.largeFile"));
                return false;
              }

              return true;
            });

            if (validFiles.length > 0) {
              const filesWithType = validFiles.map((file) => ({
                file,
                type: validFileTypes[file.type],
                preview:
                  validFileTypes[file.type] === "image"
                    ? URL.createObjectURL(file)
                    : null,
                name: file.name,
              }));

              setAttachments((prev) => [...prev, ...filesWithType]);
              setShowAttachments(true);
            }
          }
        } else {
          console.log("changing field = ", name, " with value = ", value);
          setNewAsset((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "status" && { condition: value }),
          }));
        }
      };
    } else {
      if (name === "available") {
        setMachineAvailable(value);
        console.log("name", name);
        console.log("Value", value);
      } else if (name === "fem_class") {
        setNewAsset((prev) => ({ ...prev, [name]: Number(value) }));
      } else {
        console.log("Adding new asset payload Latest Initial Assets");
        setNewAsset((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    const dt = new DataTransfer();

    for (let i = 0; i < selectedFiles.length; i++) {
      if (i !== indexToRemove) {
        dt.items.add(selectedFiles[i]);
      }
    }

    setSelectedFiles(dt.files);
  };

  const getAssetDetailsById = async (warehouseList = []) => {
    try {
      const response = await getProtected(`${API_END_POINTS.assets}${id}`);
      if (response) {
        console.log(" response =  ", response.customer_name);
        let assetData = {
          ...response,
          year_of_manufacture: normalizeYearOfManufacture(
            response.year_of_manufacture
          ),
        };

        if (response?.warehouse) {
          assetData = applyWarehouseToAssetState(
            warehouseList,
            response.warehouse,
            assetData
          );
          warehouseFieldsSyncedRef.current = true;
        }

        setNewAsset(assetData);
        if (response?.battery) {
          setNewAsset((prevState) => ({
            ...prevState,
            battery: false,
            battery_voltage: 0,
            battery_capacity: 0,
            battery_case: 0,
            battery_category: "",
          }));
        }
        setAssetAttachments(response?.attachments);
        setSelectedEngineType(response?.engine_type);
        setSelectedType(response.mast_type);
        setSelectedLoadCentre(response.load_centre);
        const equipments = response.additional_equipment || [];

        const mappedEquipments = equipments
          .map((item) =>
            typeof item === "number" ? ADD_EQUIPMENT_OPTIONS[item] : item
          )
          .filter(Boolean);
        setSelectedEquipment(mappedEquipments);
        setNewAsset((prev) => ({
          ...prev,
          additional_equipment: mappedEquipments,
        }));

        setSelectedCategory(response.asset_type);
        if (response?.battery_charger) {
          setNewAsset((prevState) => ({
            ...prevState,
            battery_charger: false,
            battery_charger_type: "",
          }));
        }
      }
    } catch (e) {
      console.error("Error getting asset:", e);
      showApiErrorToasts(
        toast,
        e?.response?.data,
        t("dashboardToasters.genricError")
      );
    } finally {
    }
  };

  const removeAttachment = (attachmentId) => {
    setAttachments((prev) =>
      prev.filter((attachment) => attachment.id !== attachmentId)
    );
  };

  const handleCreateAsset = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      // Add all asset data to formData
      Object.entries(newAsset).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "attachments") {
          const normalizedValue =
            key === "year_of_manufacture"
              ? normalizeYearOfManufacture(value)
              : value;
          formData.append(key, normalizedValue.toString());
        }
      });
      console.log("All asset data", newAsset);
      console.log("Asset data", assetData);

      // Add attachments
      attachments.forEach(({ file }) => {
        formData.append("attachments", file);
      });

      // Add documents if needed
      documents.forEach((doc) => {
        formData.append("documents", doc);
      });

      const response = assetData
        ? await postProtected(
            `${API_END_POINTS.updateAssets}/${assetData.id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
        : await postProtected(API_END_POINTS.createAssets, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

      if (response) {
        console.log("response", response);

        setNewAsset({ ...latestInitialAssets });
        setAttachments([]);
        setDocuments([]);
        setShowMediaUpload(false);
        toast.success(t("dashboardToasters.assetEditSuccess"));
      }
    } catch (e) {
      console.error("Error creating/updating asset:", e);
      showApiErrorToasts(toast, e?.response?.data, t("assets.create.fields.error"));
    }
  };

  const handleUpload = async (id) => {
    if (selectedFiles.length == 0) return;
    const formData = new FormData();
    const documentExtensions = [".pdf", ".xlsx", ".docx"];
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".webp",
      ".svg",
    ];

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      const fileName = file.name.toLowerCase();

      const fileExtension = fileName.substring(fileName.lastIndexOf("."));

      if (documentExtensions.includes(fileExtension)) {
        formData.append("documents", file);
      } else if (imageExtensions.includes(fileExtension)) {
        formData.append("images", file);
      } else {
        console.warn(
          `Unknown file type: ${fileExtension} for file: ${file.name}`
        );
        formData.append("other", file);
      }
    }

    try {
      const url = `${baseURL}/assets/${id}/attachments/`;
      const response = await postProtected(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response after uploading files = ", response);
    } catch (error) {
      console.log("error status = ", error.response?.status);
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      } else if (error.response?.status === 413) {
        toast.error(t("dashboardToasters.largeFile"));
        navigate("/login");
        return;
      }
      toast.error(t("dashboardToasters.largeFile"));
      console.error("Upload failed", error.response?.data || error.message);
    }
  };
  const handleAssetDetailsUpdateApi = async (e) => {
    e.preventDefault();
    console.log("Asset update data", newAsset);

    // setNewAsset((prev) => {
    //   const key = prev?.contracts ;
    //   if(key) {
    //     return ;
    //   }
    //   return {
    //     ...prev ,
    //   }
    // })

    const { contracts, ...payload } = newAsset;
    if (payload.year_of_manufacture != null) {
      payload.year_of_manufacture = normalizeYearOfManufacture(
        payload.year_of_manufacture
      );
    }
    try {
      setIsLoading(true);
      const response = await patchProtected(
        `${API_END_POINTS.assets}${id}/`,
        payload
      );
      console.log("response for updating asset", response);
      if (response?.data?.id) {
        if (selectedFiles) {
          await handleUpload(response?.data?.id);
        }
        setSelectedFiles(null);
        toast.success(t("assets.create.fields.updateSuccess"));
        navigate("/dashboard");
      }
    } catch (e) {
      setIsLoading(false);
      console.log("error = e", e);
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      } else if (e.response?.status === 413) {
        toast.error(t("dashboardToasters.largeFile"));
        navigate("/login");
        return;
      }
      console.error("Error updating asset:", e);
      showApiErrorToasts(toast, e?.response?.data, t("assets.create.fields.error"));
    } finally {
      setIsLoading(false);
    }
  };
  const handleNextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handlePlatformChange = (e) => {
    const value = e.target.value;
    console.log("selected platform", value);
    setNewAsset({
      ...newAsset,
      platform: JSON.stringify(value),
    });
    setSelectedPlatform(value);

    // Clear custom input if a predefined option is selected
    if (value !== "other") {
      setCustomPlatform("");
    }
  };

  const handleVisibleChange = (e) => {
    setSelectedVisibleOption(e.target.value);
    setNewAsset({
      ...newAsset,
      visible: e.target.value,
    });
  };

  const generateUniqueID = () => {
    const randomID = Math.floor(1000000 + Math.random() * 9000000).toString();
    setUniqueID(randomID);
  };

  useEffect(() => {
    warehouseFieldsSyncedRef.current = false;
  }, [id]);

  useEffect(() => {
    if (
      warehouseFieldsSyncedRef.current ||
      !warehouses.length ||
      !(newAsset?.warehouse || warehouseLocationId)
    ) {
      return;
    }

    const warehouseId = newAsset?.warehouse || warehouseLocationId;
    const warehouse = findWarehouseById(warehouses, warehouseId);
    if (!warehouse) {
      return;
    }

    warehouseFieldsSyncedRef.current = true;
    setSelectedWarehouse(warehouse);
    setWarehouseLocationId(warehouse.id);
    setNewAsset((prev) => ({
      ...prev,
      ...getWarehouseAddressFields(warehouse, prev),
    }));
  }, [warehouses, newAsset?.warehouse, warehouseLocationId]);

  useEffect(() => {
    (async () => {
      setIsLoadingEditPage(true);
      const warehouseList = await getWarehouses();
      await generateUniqueID();
      await getAssetDetailsById(warehouseList);
      setIsLoadingEditPage(false);
    })();
  }, []);

  const handleUniqueIDChange = (e) => {
    setUniqueID(e.target.value);
    setNewAsset({
      ...latestInitialAssets,
      asset_id: e.target.value,
    });
  };

  const handleAttachmentChange = (e) => {
    const value = e.target.value;
    setSelectedAttachment(value);

    // Clear custom input if a predefined option is selected
    if (value !== "other") {
      setCustomAttachment("");
    }
  };
  const handleEquipmentChange = (e) => {
    const value = e.target.value;

    // If "other" is selected, keep the custom equipment input; otherwise, clear it
    if (value === "other") {
      setSelectedEquipment((prev) => [...prev, value]); // Add "other" to selected equipment
    } else {
      setSelectedEquipment(value); // Set selected equipment to the chosen option
      setCustomEquipment(""); // Clear custom equipment input
    }
  };

  // Example of defining visibleOptions based on some criteria
  const visibleOptions = attachments.filter(
    (attachment) => attachment.isVisible
  );

  // New function to handle step click
  const handleStepClick = (index) => {
    setCurrentStep(index);
  };

  // fxn's for changing state for battery Available

  const handleBatteryAvailable = (event) => {
    const value = event.target.value === "true"; // Convert string to boolean
    setIsBatteryAvailable(value);
    setNewAsset({
      ...newAsset,
      battery: value,
    });
    console.log("Battery Available:", value);
  };
  const handleBatteryChargerAvailable = (event) => {
    const value = event.target.value === "true"; // Convert string to boolean
    setIsBatteryChargerAvailable(value);
    setNewAsset({
      ...newAsset,
      battery_charger: value,
    });
    console.log("Battery Charger Available:", value);
  };
  const InputWithExplanation = ({ label, explanation, children }) => {
    return (
      <div className="form-group">
        <div className="field-label-container">
          <label>{label}</label>
          <div className="explanation-icon">
            <i className="fas fa-info-circle" />
            <div className="explanation-tooltip">{explanation}</div>
          </div>
        </div>
        {children}
      </div>
    );
  };
  const Step = ({ step, index, currentStep, steps, handleStepClick }) => {
    return (
      <div
        className={`flex flex-col items-center mx-1 sm:mx-2 md:mx-4 ${
          index === 0
            ? "step1"
            : index === 1
            ? "step2"
            : index === 2
            ? "step3"
            : "step4"
        }`}
        key={index}
        onClick={() => handleStepClick(index)}
      >
        <div
          className={`flex items-center justify-center -full w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 cursor-pointer transition-colors duration-300 ${
            currentStep >= index
              ? "bg-blue-500 text-white"
              : "bg-gray-200 text-gray-500"
          }`}
        >
          {step.icon}
        </div>

        {index < steps.length - 1 && (
          <div className="hidden sm:block h-1 w-16 md:w-24 lg:w-32 bg-gray-200 mt-4">
            <div
              className={`h-full ${
                currentStep > index ? "bg-blue-500" : "bg-gray-200"
              }`}
            />
          </div>
        )}

        <div
          className={`mt-2 text-xs sm:text-sm md:text-base text-center transition-colors duration-300 ${
            currentStep === index
              ? "font-bold text-black"
              : "font-normal text-gray-500"
          }`}
        >
          {step.title}
        </div>
      </div>
    );
  };

  const ButtonList = () => {
    return (
      <div className="mx-2 sm:mx-4 w-full overflow-x-auto my-2 flex items-center bg-white py-2 shadow-md">
        <div className="flex space-x-1 sm:space-x-2 px-2 sm:px-0 min-w-max mx-auto">
          {categories.map((category, index) => (
            <button
              key={index}
              disabled={selectedCategory !== category.value}
              className={`font-medium py-[.5rem] px-[.6rem] sm:px-[.8rem] text-xs sm:text-sm md:text-base gap-2 transition-colors duration-200 whitespace-nowrap ${
                selectedCategory === category.value
                  ? "bg-blue-500 hover:bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-800 cursor-not-allowed"
              }`}
              onClick={() => {
                // setSelectedCategory(category);
                // setNewAsset((prev) => {
                //   return {
                //     ...prev,
                //     asset_type: category,
                //   };
                // });
              }}
            >
              {category.option}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const handleRadioChange = (value) => {
    setNewAsset((prev) => ({
      ...prev,
      freihub: value,
    }));
  };

  const handleFileChange = (e) => {
    console.log("handleFileChange triggered = ", selectedFiles);
    const dt = new DataTransfer();
    for (let i = 0; i < selectedFiles.length; i++) {
      dt.items.add(selectedFiles[i]);
    }
    for (let i = 0; i < e.target.files.length; i++) {
      dt.items.add(e.target.files[i]);
    }
    setSelectedFiles(dt.files);
  };

  if (isLoadingEditPage) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
        <div className="text-center px-4 w-full max-w-sm">
          <div className="mx-auto h-12 w-12 sm:h-14 sm:w-14 mb-4 sm:mb-6">
            <div className="animate-spin h-full w-full border-4 sm:border-8 border-gray-200 border-t-blue-500 rounded-full"></div>
          </div>
          <div className="text-white text-lg sm:text-xl font-medium break-words">
            {/* {t("detailViewModel.loadingDetailView")} */}
            {t("detailViewModel.loadingEditPage")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-y-auto  w-full min-h-screen bg-gray-100 ">
      <HeroSection t={t} />
      <h1 className="px-4 py-2  font-medium text-3xl ">Edit Asset</h1>
      <ButtonList />
      <div className="w-full px-2 py-2 sm:px-4 md:px-6 lg:px-8">
        <div className="flex flex-row justify-between items-stretch w-full shadow-sm">
          {steps.map((step, index) => (
            <div
              className="relative border-2 border-gray-200 bg-white p-1 sm:p-2 md:p-3 lg:p-4 flex flex-col items-center flex-1 min-w-0 h-full"
              key={index}
            >
              {/* Step circle */}
              <div
                className={`flex items-center justify-center rounded-full border-2 ${
                  currentStep === index
                    ? "bg-blue-500 border-blue-500 text-white"
                    : "bg-white border-gray-300 text-gray-400"
                } w-6 h-6 xs:w-7 xs:h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 xl:w-14 xl:h-14 border-2 border-blue-500 z-10 cursor-pointer transition-colors duration-300`}
                onClick={() => handleStepClick(index)}
              >
                <span className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl">
                  {step.icon}
                </span>
              </div>

              {/* Step title */}
              <div className="mt-1 sm:mt-2 md:mt-3 lg:mt-4 text-center w-full px-1 flex-grow flex items-end">
                <div
                  className={`text-xs xs:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-medium leading-tight w-full ${
                    currentStep === index
                      ? "text-blue-500 font-bold"
                      : currentStep > index
                      ? "text-gray-700"
                      : "text-gray-400"
                  }`}
                >
                  <span className="block sm:inline break-words hyphens-auto">
                    {step.title}
                  </span>
                </div>
              </div>

              {/* Connector line */}
            </div>
          ))}
        </div>
      </div>
      <form
        onSubmit={handleAssetDetailsUpdateApi}
        className="w-full px-4 py-1 "
      >
        <div className="flex gap-2 items-center mb-2">
          <button
            variant="primary"
            type="button"
            onClick={() => navigate("/dashboard")}
            className="bg-gray-200  text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
          >
            {t("common.cancel")}
          </button>
          {currentStep === 2 ? (
            <button
              type="button"
              onClick={() => {
                console.log("create contract ......");
                console.log("contract form = ", contractForm);
                handleCreateContract();
              }}
              className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={isLoading}
            >
              {t("common.buttons.save")}
            </button>
          ) : (
            <button
              type="submit"
              className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={isLoading}
            >
              {t("common.buttons.save")}
            </button>
          )}
          {currentStep === 2 && (
            <div className="flex justify-end items-center ml-auto">
              <button
                type="button"
                onClick={() => {
                  navigate(`/transport-order/${id}`);
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm sm:text-base whitespace-nowrap"
              >
                {t("common.buttons.transport")}
              </button>
            </div>
          )}
        </div>
        {currentStep === 0 && (
          <>
            {selectedCategory === "Chargers" && (
              <Chargers
                t={t}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
              />
            )}

            {selectedCategory === "Batteries" && (
              <Batteries
                handleRemoveFile={handleRemoveFile}
                selectedFiles={selectedFiles}
                formatAttachment={formatAttachment}
                handleDeleteAttachment={handleDeleteAttachment}
                assetAttachments={assetAttachments}
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleFileChange={handleFileChange}
                handleWarehouseChange={handleWarehouseChange}
                warehouseLocationId={warehouseLocationId}
              />
            )}

            {selectedCategory === "Forklifts" && (
              <div className="w-full flex flex-col gap-4 ">
                {/* Basic Information */}
                <div className="bg-white p-4 shadow-md  ">
                  <h2 className="text-xl font-medium mb-3  text-gray-800">
                    {t("assetPageHeadings.basics")}
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                    {/* Row 1: Manufacturer and Serial Number */}
                    <div className="col-span-1 md:col-span-1 lg:col-span-1 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-2">
                      <div>
                        <InputField
                          required
                          name="manufacturer"
                          value={newAsset.manufacturer}
                          maxLength={100}
                          onChange={handleChange}
                          label={t("assets.fields.manufacturer")}
                          explanation={t(
                            "assets.fields.explanation.manufacturer"
                          )}
                          placeholder={t(
                            "createAsset.placeholder.enterManufacturer"
                          )}
                        />
                      </div>

                      <div className="">
                        <InputField
                          name="type"
                          value={newAsset.type}
                          onChange={handleChange}
                          label={t("assets.fields.type")}
                          explanation={t("assets.fields.explanation.type")}
                          placeholder={t("createAsset.placeholder.enterType")}
                          maxLength={30}
                        />
                      </div>
                    </div>

                    <div className="gap-2 col-span-1 md:col-span-1 lg:col-span-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                      <div>
                        <SelectField
                          name="classification"
                          value={newAsset.classification}
                          onChange={handleChange}
                          label={t("assets.fields.classification")}
                          explanation={t(
                            "assets.fields.explanation.classification"
                          )}
                          placeholder={t(
                            "createAsset.placeholder.enterClassification"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t("assets.fields.selectClassification"),
                            },
                            ...[
                              "Other",
                              "Rough-terrain-forklift",
                              "Container-Stacker",
                              "Reach-stacker",
                              "Terminal tractor",
                              "Tractor",
                              "Trailer",
                              "Electric platform trucks",
                              "Electric 3-wheel",
                              "Electric 4-wheel",
                              "Diesel Forklift",
                              "Compact Forklift Truck",
                              "LPG Forklift",
                              "Pallet truck",
                              "Pallet Trucks Sit-down",
                              "Scissor elevating truck platform",
                              "Lift trucks with scales",
                              "Hand pallet truck",
                              "Horizontal order picker",
                              "Vertical order picker",
                              "High-lift pallet truck",
                              "Stacker stand-on",
                              "High lift pallet trucks sit-down",
                              "Reach truck",
                              "Narrow aisle truck",
                              "Telescopic forklift, fixed",
                              "Telescopic forklift, rotating",
                              "Four-way loader",
                              "Four-way reachtruck",
                              "Sideloader",
                              "Truck mounted forklift",
                              "Tugger-train-trailer",
                              "CNG-Forklift",
                              "Gasoline-Forklift",
                              "Electric stairclimber",
                              "Counterbalance forklift (see Appendix M)",
                            ].map((key) => ({
                              value: key,
                              option: t(`classification.${key}`),
                            })),
                          ]}
                        />
                      </div>

                      <div>
                        <InputField
                          required
                          name="serial_no"
                          value={newAsset.serial_no}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholder.enterSerialNumber"
                          )}
                          label={`${t("assets.fields.machineSerialNo")} `}
                          explanation={t(
                            "assets.fields.explanation.machineSerialNo"
                          )}
                          maxLength={100}
                        />
                      </div>

                      <div className="">
                        <InputField
                          name="intern_no"
                          value={newAsset.intern_no}
                          onChange={handleChange}
                          maxLength={100}
                          placeholder={t(
                            "createAsset.placeholders.internNoPlaceholder"
                          )}
                          label={t("createAsset.placeholders.internNoLabel")}
                          explanation={t(
                            "createAsset.placeholders.internNoExplanation"
                          )}
                        />
                      </div>

                      <div className="">
                        <SelectField
                          name="status"
                          value={newAsset.status}
                          onChange={handleChange}
                          label={`${t("assets.fields.status")} *`}
                          explanation={t("assets.fields.explanation.status")}
                          placeholder={t("createAsset.placeholder.enterStatus")}
                          menus={[
                            {
                              value: "",
                              option: t("assets.fields.selectStatus"),
                            },
                            { value: "New", option: t("assets.options.new") },
                            { value: "Used", option: t("assets.options.used") },
                            {
                              value: "Short Time Hire",
                              option: t("assets.options.shortTermHire"),
                            },
                            {
                              value: "Demo",
                              option: "Demo",
                            },
                          ]}
                        />
                      </div>
                    </div>
                    {/* Row 2: Engine Type and Classification */}
                  </div>

                  {/* Row 3: Status, Country, Zip, and City all in one row */}
                  <div className="col-span-2 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-2">
                    <div>
                      <InputField
                        required
                        name="year_of_manufacture"
                        value={newAsset.year_of_manufacture || ""}
                        onChange={handleChange}
                        label={t("assets.fields.yearOfManufacture")}
                        explanation={t(
                          "assets.fields.explanation.yearOfManufacture"
                        )}
                        placeholder={t(
                          "createAsset.placeholder.enterYearOfManufacture"
                        )}
                        type="year"
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="operating_hours"
                        type="number"
                        value={newAsset.operating_hours}
                        onChange={handleChange}
                        label={t("assets.fields.operatingHours")}
                        explanation={t(
                          "assets.fields.explanation.operatingHours"
                        )}
                        placeholder="Enter operating hours"
                        maxLength={8}
                      />
                    </div>

                    <div>
                      <InputField
                        name="capacity"
                        type="number"
                        value={newAsset.capacity}
                        onChange={handleChange}
                        label={t("assets.fields.capacity")}
                        explanation={t("assets.fields.explanation.capacity")}
                        placeholder={t("createAsset.placeholder.enterCapacity")}
                        maxLength={10}
                      />
                    </div>

                    <div>
                      <InputField
                        name="lift_height_mm"
                        type="number"
                        value={newAsset.lift_height_mm}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.liftHeight")}
                        explanation={t(
                          "createAsset.placeholders.liftHeightExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.liftHeightPlaceholder"
                        )}
                        maxLength={4}
                      />
                    </div>

                    <div>
                      <InputField
                        type="number"
                        name="machine_height_mm"
                        maxLength={4}
                        value={newAsset.machine_height_mm}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.machineHeight")}
                        explanation={t(
                          "createAsset.placeholders.machineHeightPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineHeightExplanation"
                        )}
                      />
                    </div>

                    <div className="col-span-1 flex gap-2 items-center">
                      <SelectField
                        name="mast_type"
                        value={selectedType}
                        onChange={(e) => {
                          const newType = e.target.value;
                          setSelectedType(newType);
                          setNewAsset((prev) => ({
                            ...prev,
                            mast_type: newType,
                          }));
                        }}
                        label={t("createAsset.placeholders.mastTypeLabel")}
                        explanation={t(
                          "createAsset.placeholders.mastTypeExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.mastTypePlaceholder"
                        )}
                        menus={[
                          {
                            value: "",
                            option: t(
                              "createAsset.placeholders.mastTypePlaceholder"
                            ),
                          },
                          ...mastTypes.map((type) => ({
                            value: type?.value,
                            option: t(
                              `assetDetails.mastTypes.${type?.type.toLowerCase()}`
                            ),
                          })),
                        ]}
                      />
                    </div>

                    {Array.isArray(warehouses) && warehouses?.length > 0 && (
                      <div className="col-span-1 md:col-span-2 lg:col-span-2">
                        <SelectField
                          name="warehouse"
                          value={
                            selectedWarehouse?.id || warehouseLocationId || ""
                          }
                          onChange={(e) => {
                            handleWarehouseChange(e);
                          }}
                          label={t("createAsset.placeholders.warehouseLabel")}
                          explanation={t(
                            "createAsset.placeholders.warehouseExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.warehousePlaceholder"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.warehousePlaceholder"
                              ),
                            },
                            ...warehouses.map((warehouse) => {
                              return {
                                value: warehouse.id,
                                option: warehouse.name,
                              };
                            }),
                          ]}
                        />
                      </div>
                    )}

                    <div>
                      <InputField
                        required
                        name="dealer_street"
                        value={newAsset.dealer_street}
                        onChange={handleChange}
                        maxLength={20}
                        label={t("createAsset.placeholders.street")}
                        placeholder={t(
                          "createAsset.placeholders.streetPlaceholder"
                        )}
                        explanation={t(
                          "createAsset.placeholders.streetExplanation"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="dealer_city"
                        value={newAsset.dealer_city}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.city")}
                        explanation={t(
                          "createAsset.placeholders.cityExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.cityPlaceholder"
                        )}
                        maxLength={50}
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="dealer_country"
                        value={newAsset.dealer_country}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.country")}
                        explanation={t(
                          "createAsset.placeholders.countryExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.countryPlaceholder"
                        )}
                        maxLength={50}
                      />
                    </div>

                    <div>
                      <InputField
                        required
                        name="dealer_zip"
                        value={newAsset.dealer_zip}
                        onChange={handleChange}
                        type="number"
                        label={t("createAsset.placeholders.zipCode")}
                        explanation={t(
                          "createAsset.placeholders.zipCodePlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.zipCodeExplanation"
                        )}
                        maxLength={7}
                      />
                    </div>

                    <div className="col-span-1 md:col-span-3 lg:col-span-4">
                      <div className="flex items-center gap-4">
                        <div className="flex-1">
                          <SelectField
                            name="technical_condition"
                            value={newAsset.technical_condition}
                            onChange={handleChange}
                            label={t(
                              "createAsset.placeholders.technicalConditionLabel"
                            )}
                            explanation={t(
                              "createAsset.placeholders.technicalConditionExplanation"
                            )}
                            placeholder={t(
                              "createAsset.placeholders.technicalConditionPlaceholder"
                            )}
                            menus={[
                              {
                                value: "",
                                option: t(
                                  "createAsset.placeholders.technicalConditionPlaceholder"
                                ),
                              },
                              {
                                value: 2,
                                option: t(
                                  "createAsset.technicalCondition.very_good"
                                ),
                              },
                              {
                                value: 3,
                                option: t(
                                  "createAsset.technicalCondition.good"
                                ),
                              },
                              {
                                value: 4,
                                option: t(
                                  "createAsset.technicalCondition.used"
                                ),
                              },
                              {
                                value: 5,
                                option: t("createAsset.technicalCondition.bad"),
                              },
                              {
                                value: 6,
                                option: t(
                                  "createAsset.technicalCondition.very_bad"
                                ),
                              },
                              {
                                value: 7,
                                option: t("createAsset.technicalCondition.new"),
                              },
                            ]}
                          />
                        </div>

                        <div className="flex-1 col-span-2">
                          <SelectField
                            name="optical_condition"
                            value={newAsset.optical_condition}
                            onChange={handleChange}
                            label={t(
                              "createAsset.placeholders.opticalConditionLabel"
                            )}
                            explanation={t(
                              "createAsset.placeholders.opticalConditionExplanation"
                            )}
                            placeholder={t(
                              "createAsset.placeholders.opticalConditionPlaceholder"
                            )}
                            menus={[
                              {
                                value: "",
                                option: t(
                                  "createAsset.placeholders.opticalConditionPlaceholder"
                                ),
                              },
                              {
                                value: 2,
                                option: t(
                                  "createAsset.opticalCondition.very_good"
                                ),
                              },
                              {
                                value: 3,
                                option: t("createAsset.opticalCondition.good"),
                              },
                              {
                                value: 4,
                                option: t("createAsset.opticalCondition.used"),
                              },
                              {
                                value: 5,
                                option: t("createAsset.opticalCondition.bad"),
                              },
                              {
                                value: 6,
                                option: t(
                                  "createAsset.opticalCondition.very_bad"
                                ),
                              },
                              {
                                value: 7,
                                option: t("createAsset.opticalCondition.new"),
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 flex items-center col-span-1 md:col-span-3 lg:col-span-2 w-full">
                      <div className="flex flex-col gap-2 w-full">
                        <SelectField
                          name="engine_type"
                          value={selectedEngineType}
                          onChange={(e) => {
                            const newType = e.target.value;
                            setSelectedEngineType(newType);
                            setNewAsset((prev) => ({
                              ...prev,
                              engine_type: newType,
                            }));
                          }}
                          label={t("createAsset.placeholders.engineTypeLabel")}
                          explanation={t(
                            "createAsset.placeholders.engineTypeExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.engineTypePlaceholder"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.engineTypePlaceholder"
                              ),
                            },
                            ...engineTypeOptions.map((type) => ({
                              value: type,
                              option: t(`engineTypes.${type}`),
                            })),
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-4 shadow-md">
                  <h2 className="text-xl font-medium mb-3 text-gray-800">
                    {t("assetPageHeadings.details")}
                  </h2>

                  {/* Regular fields in responsive grid layout */}
                  <div className="grid grid-cols-1 gap-2 gap-y-2">
                    <div className="col-span-1 sm:col-span-3 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-4 mr-4">
                      <InputField
                        name="closed_height_mm"
                        type="number"
                        value={newAsset.closed_height_mm || ""}
                        onChange={handleChange}
                        maxLength={4}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.closedHeight")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.closedHeightExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.closedHeigthPlaceholder"
                        )}
                      />
                      <InputField
                        type="number"
                        name="machine_length_mm"
                        value={newAsset.machine_length_mm}
                        onChange={handleChange}
                        maxLength={4}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.machineLength")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.machineLengthExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineLengthPlaceholder"
                        )}
                      />

                      <InputField
                        type="number"
                        name="machine_width_mm"
                        maxLength={4}
                        value={
                          newAsset.machine_width_mm > 0 &&
                          newAsset.machine_width_mm
                        }
                        onChange={handleChange}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.machineWidth")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.machineWidthPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineWidthExplanation"
                        )}
                      />

                      <InputField
                        type="number"
                        name="machine_weight_kg"
                        maxLength={4}
                        value={newAsset.machine_weight_kg}
                        onChange={handleChange}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.machineWeigth")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.machineWeigthPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.machineWeigthExplanation"
                        )}
                      />

                      <InputField
                        type="number"
                        name="load_center_mm"
                        maxLength={4}
                        value={newAsset.load_center_mm}
                        onChange={handleChange}
                        label={
                          <span className="whitespace-nowrap">
                            {t("createAsset.placeholders.loadCenter")}
                          </span>
                        }
                        explanation={t(
                          "createAsset.placeholders.loadCenterPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.loadCenterExplanation"
                        )}
                      />
                    </div>

                    <div className="col-span-1 flex gap-2 items-center">
                      <div className="flex gap-2">
                        <div className="flex items-center flex-wrap gap-2">
                          {loadCentreOptions.map((load_center, index) => (
                            <button
                              type="button"
                              key={index}
                              className={`px-2 py-2 -md border transition-colors ${
                                selectedLoadCenter === index
                                  ? "bg-blue-500 hover:bg-blue-600 text-white "
                                  : "bg-white text-gray-800 border-gray-300 hover:bg-gray-100"
                              }`}
                              onClick={() => {
                                setSelectedLoadCentre(index);
                                setNewAsset((prev) => {
                                  return {
                                    ...prev,
                                    load_centre: index,
                                  };
                                });
                              }}
                            >
                              {load_center}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <div className="w-full">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {t("assets.create.fields.selectEquipment")}
                        </label>

                        <div className="relative">
                          {/* Custom Dropdown Trigger */}
                          <div
                            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white cursor-pointer hover:border-gray-400 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 min-h-[38px] flex items-center justify-between"
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                          >
                            <div className="flex-1 flex flex-wrap gap-1 items-center">
                              {selectedEquipment &&
                              selectedEquipment.length > 0 ? (
                                selectedEquipment.map(
                                  (equipmentItem, index) => (
                                    <span
                                      key={index}
                                      className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                                    >
                                      {equipmentItem
                                        ? t(
                                            `assets.options.${getEquipmentKey(
                                              equipmentItem
                                            )}`
                                          )
                                        : ""}{" "}
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const currentSelection =
                                            selectedEquipment || [];
                                          const newSelection =
                                            currentSelection.filter(
                                              (item) => item !== equipmentItem
                                            );
                                          setSelectedEquipment(newSelection);
                                          const syntheticEvent = {
                                            target: {
                                              name: "additional_equipment",
                                              value: newSelection,
                                            },
                                          };
                                          handleChange(syntheticEvent);
                                        }}
                                        className="ml-1 inline-flex items-center justify-center w-4 h-4 text-blue-400 hover:bg-blue-200 hover:text-blue-500 focus:outline-none focus:bg-blue-500 focus:text-white rounded-full"
                                      >
                                        <span className="sr-only">Remove</span>
                                        <svg
                                          className="w-2 h-2"
                                          stroke="currentColor"
                                          fill="none"
                                          viewBox="0 0 8 8"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeWidth="1.5"
                                            d="m1 1 6 6m0-6-6 6"
                                          />
                                        </svg>
                                      </button>
                                    </span>
                                  )
                                )
                              ) : (
                                <span className="text-gray-500 text-sm">
                                  Select equipment...
                                </span>
                              )}
                            </div>

                            {/* Dropdown Arrow */}
                            <svg
                              className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${
                                isDropdownOpen ? "transform rotate-180" : ""
                              }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>

                          {/* Dropdown Options */}
                          {isDropdownOpen && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                              {ADD_EQUIPMENT_OPTIONS.map((option, index) => {
                                const isSelected =
                                  selectedEquipment?.includes(option);
                                return (
                                  <div
                                    key={index}
                                    className={`px-3 py-2 cursor-pointer hover:bg-gray-50 flex items-center justify-between ${
                                      isSelected
                                        ? "bg-blue-50 text-blue-700"
                                        : "text-gray-900"
                                    }`}
                                    onClick={() => {
                                      const currentSelection =
                                        selectedEquipment || [];
                                      let newSelection;

                                      if (isSelected) {
                                        // Remove if already selected
                                        newSelection = currentSelection.filter(
                                          (item) => item !== option
                                        );
                                      } else {
                                        // Add if not selected
                                        newSelection = [
                                          ...currentSelection,
                                          option,
                                        ];
                                      }

                                      console.log(
                                        "value ====== ",
                                        newSelection
                                      );
                                      setSelectedEquipment(newSelection);

                                      // Create a synthetic event for handleChange
                                      const syntheticEvent = {
                                        target: {
                                          name: "additional_equipment",
                                          value: newSelection,
                                        },
                                      };
                                      handleChange(syntheticEvent);
                                    }}
                                  >
                                    <span className="flex-1">
                                      {t(
                                        `assets.options.${getEquipmentKey(
                                          option
                                        )}`
                                      )}
                                    </span>{" "}
                                    {isSelected && (
                                      <svg
                                        className="w-4 h-4 text-blue-600"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>

                        {/* Hidden select for form compatibility (optional) */}
                        <select
                          multiple
                          name="additional_equipment"
                          value={selectedEquipment || []}
                          onChange={() => {}} // Handled by custom dropdown
                          className="hidden"
                          tabIndex={-1}
                        >
                          {ADD_EQUIPMENT_OPTIONS.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        {/* Click outside handler */}
                        {isDropdownOpen && (
                          <div
                            className="fixed inset-0 z-0"
                            onClick={() => setIsDropdownOpen(false)}
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <TextAreaField
                        name="additional_equipment_description"
                        value={newAsset.additional_equipment_description}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.additonalEquipmentDescription"
                        )}
                        explanation={t(
                          "createAsset.placeholders.additionalEquipmentDescriptionExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.addtionalEquipmentDescriptionPlaceholder"
                        )}
                      />
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <TextAreaField
                        name="description"
                        value={newAsset.description}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.additionalDescription"
                        )}
                        explanation={t(
                          "createAsset.placeholders.cityPlaadditionalDescriptionExplanationceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.additionalDescriptionPlaceholder"
                        )}
                      />
                    </div>

                    <div className="col-span-1 md:col-span-1 lg:col-span-5">
                      <TextAreaField
                        name="engine_description"
                        value={newAsset.engine_description}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.engineDescription")}
                        explanation={t(
                          "createAsset.placeholders.engineDiscriptionExplantion"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.engineDiscriptionPlaceholder"
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 shadow-md w-full mx-auto ">
                  <h2 className="text-xl font-medium text-gray-800 mb-6">
                    Mast
                  </h2>

                  {/* Mast Type Selection */}
                  <div className="mb-6">
                    <SelectField
                      name="mast_type"
                      value={selectedType}
                      onChange={(e) => {
                        const newType = e.target.value;
                        setSelectedType(newType);
                        setNewAsset((prev) => ({
                          ...prev,
                          mast_type: newType,
                        }));
                      }}
                      label={t("createAsset.placeholders.mastTypeLabel")}
                      explanation={t(
                        "createAsset.placeholders.mastTypeExplanation"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.mastTypePlaceholder"
                      )}
                      menus={[
                        {
                          value: "",
                          option: t(
                            "createAsset.placeholders.mastTypePlaceholder"
                          ),
                        },
                        ...mastTypes.map((type) => ({
                          value: type?.value,
                          option: t(
                            `assetDetails.mastTypes.${type.type.toLowerCase()}`
                          ),
                        })),
                      ]}
                    />
                  </div>

                  {/* Mast Description */}
                  <div className="mb-2 w-full ">
                    <TextAreaField
                      name="mast_description"
                      value={newAsset.mast_description}
                      onChange={handleChange}
                      label={t("createAsset.placeholders.mastDescription")}
                      explanation={t(
                        "createAsset.placeholders.mastDescriptionPlaceholder"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.mastDescriptionExplanation"
                      )}
                    />
                  </div>

                  {/* Main Grid Container - Responsive CSS Grid Layout */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">
                    {/* Freihub Radio Buttons */}
                    <div className="mb-6 col-span-1 ">
                      <p className="text-sm font-semibold text-gray-700 mb-3">
                        {t("createAsset.placeholders.freihub")}
                      </p>
                      <div className="flex items-center space-x-6">
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="freihub"
                            value="true"
                            checked={newAsset.freihub === true}
                            onChange={() => handleRadioChange(true)}
                            className="mr-2 text-blue-500 focus:ring-blue-500"
                          />
                          <span className="text-gray-700">
                            {t("createAsset.placeholders.friehubYes")}
                          </span>
                        </label>
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="freihub"
                            value="false"
                            checked={newAsset.freihub === false}
                            onChange={() => handleRadioChange(false)}
                            className="mr-2 text-blue-500 focus:ring-blue-500"
                          />
                          <span className="text-gray-700">
                            {t("createAsset.placeholders.freihubNo")}
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* Forks Description */}
                    <div className="mb-2 col-span-1 md:col-span-1 lg:col-span-1">
                      <InputField
                        name="forks_description"
                        value={newAsset.forks_description}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.forks")}
                        explanation={t(
                          "createAsset.placeholders.forksDescription"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.forksExplanation"
                        )}
                        rows={3}
                      />
                    </div>

                    {/* Fork Carriage */}
                    <div className="mb-2 col-span-1 md:col-span-1 lg:col-span-1">
                      <InputField
                        name="fork_carriage"
                        value={newAsset.fork_carriage}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.forkCarriageLabel")}
                        explanation={t(
                          "createAsset.placeholders.forkCarriageExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.forkCarriagePlaceholder"
                        )}
                      />
                    </div>

                    {/* Free Height */}
                    <div className="mb-2 col-span-1 md:col-span-1 lg:col-span-1">
                      <InputField
                        type="number"
                        name="free_height"
                        value={newAsset.free_height}
                        maxLength={10}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.forkLengthLabel")}
                        explanation={t(
                          "createAsset.placeholders.forkLengthExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.forkLengthPlaceholder"
                        )}
                      />
                    </div>
                  </div>

                  {/* Fork Carriage Description - Full Width */}
                  <div className="mt-2">
                    <TextAreaField
                      name="fork_carriage_description"
                      value={newAsset.fork_carriage_description}
                      onChange={handleChange}
                      label={t(
                        "createAsset.placeholders.forkCarrDescriptionLabel"
                      )}
                      explanation={t(
                        "createAsset.placeholders.forkCarrDescriptionExplanation"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.forkCarrDescriptionPlaceholder"
                      )}
                    />
                  </div>

                  {/* Debug: Show current state */}
                </div>

                <div className="bg-white p-4 shadow-md">
                  <h2 className="text-xl font-medium mb-3 text-gray-800">
                    {t("assetPageHeadings.batteryAndCharger")}
                  </h2>

                  <h4 className="mb-3 font-medium">Battery</h4>

                  <div>
                    {/* Row 1: Battery Manufacturer, Battery Model, Battery Type, Nominal Voltage, Battery Capacity */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 mb-2">
                      <div className="flex flex-col">
                        <InputField
                          label={t(
                            "createAsset.placeholders.batteryManufacturer"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryManufacturerExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.batteryManufacturerPlaceholder"
                          )}
                          maxLength={100}
                          name="battery_manufacturer"
                          value={newAsset.battery_manufacturer}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryModelPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryModel")}
                          explanation={t(
                            "createAsset.placeholders.batteryModelExplanation"
                          )}
                          type="text"
                          name="batterymodel"
                          value={newAsset.batterymodel}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                          maxLength={100}
                        />
                      </div>

                      <div className="flex flex-col">
                        <SelectField
                          name="battery_type"
                          value={newAsset.battery_type}
                          onChange={handleChange}
                          label={t("createAsset.placeholders.batteryType")}
                          explanation={t(
                            "createAsset.placeholders.batteryTypeExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.batteryTypeExplanation"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.batteryTypeExplanation"
                              ),
                            },
                            { value: 1, option: t("assets.options.none") },
                            { value: 2, option: t("assets.options.pzs") },
                            { value: 3, option: t("assets.options.gel") },
                            {
                              value: 4,
                              option: t("assets.options.lithium-ion"),
                            },
                            { value: 5, option: t("assets.options.starter") },
                            { value: 6, option: t("assets.options.waterless") },
                            {
                              value: 7,
                              option: t("assets.options.tppl"),
                            },
                            { value: 8, option: t("assets.options.nimh") },
                            {
                              value: 9,
                              option: t("assets.options.battery_others"),
                            },
                          ]}
                        />
                      </div>

                      <div className="flex flex-col">
                        <SelectField
                          name="battery_voltage"
                          value={newAsset.battery_voltage}
                          onChange={handleChange}
                          label={t(
                            "createAsset.placeholders.batteryNominalVoltage"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryNominalVoltageExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.selectNominalVoltagePlaceholder"
                          )}
                          menus={[
                            {
                              value: "",
                              option: t(
                                "createAsset.placeholders.selectNominalVoltagePlaceholder"
                              ),
                            },
                            { value: "6", option: "6" },
                            { value: "8", option: "8" },
                            { value: "12", option: "12" },
                            { value: "24", option: "24" },
                            { value: "36", option: "36" },
                            { value: "48", option: "48" },
                            { value: "72", option: "72" },
                            { value: "80", option: "80" },
                            { value: "90", option: "90" },
                            { value: "96", option: "96" },
                            { value: "120", option: "120" },
                          ]}
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryCapacityPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryCapacity")}
                          explanation={t(
                            "createAsset.placeholders.batteryCapacityExplanation"
                          )}
                          type="number"
                          name="batterycapacity"
                          value={newAsset.batterycapacity}
                          onChange={handleChange}
                          maxLength={8}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>
                    </div>

                    {/* Row 2: Year of Manufacture, Length, Width, Weight, Casing */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-9 gap-2 mb-2">
                      <div className="flex flex-col lg:col-span-2">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryYOMPlaceholder"
                          )}
                          label={t(
                            "createAsset.placeholders.batteryYearOfManufacture"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryYOMExplanation"
                          )}
                          type="month"
                          name="battery_yom"
                          value={newAsset.battery_yom}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col lg:col-span-2">
                        <InputField
                          // placeholder={t(
                          //   "createAsset.placeholders.batteryYOMPlaceholder"
                          // )}
                          // label={t(
                          //   "createAsset.placeholders.batteryYearOfManufacture"
                          // )}
                          // explanation={t(
                          //   "createAsset.placeholders.batteryYOMExplanation"
                          // )}
                          placeholder={t(
                            "createAsset.placeholders.batteryAddtionalEquipmentPlaceholder"
                          )}
                          label={t(
                            "createAsset.placeholders.batteryAdditionalEquipment"
                          )}
                          explanation={t(
                            "createAsset.placeholders.batteryAddtionalEquipmentExplanation"
                          )}
                          type="test"
                          name="battery_additional_equipment"
                          value={newAsset.battery_additional_equipment}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryLengthPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryLength")}
                          explanation={t(
                            "createAsset.placeholders.batteryLengthExplanation"
                          )}
                          type="number"
                          name="batterylength"
                          value={newAsset.batterylength}
                          maxLength={8}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryWidthPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryWidth")}
                          explanation={t(
                            "createAsset.placeholders.batteryWidthExplanation"
                          )}
                          type="number"
                          name="batterywidth"
                          maxLength={10}
                          value={newAsset.batterywidth}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          placeholder={t(
                            "createAsset.placeholders.batteryWeigthPlaceholder"
                          )}
                          label={t("createAsset.placeholders.batteryWeigth")}
                          explanation={t(
                            "createAsset.placeholders.batteryWeigthExplanation"
                          )}
                          type="number"
                          name="batteryweight"
                          value={newAsset.batteryweight}
                          maxLength={8}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.batteryCasing")}
                          placeholder={t(
                            "createAsset.placeholders.batteryCasingPlaceholder"
                          )}
                          type="text"
                          name="batteryCasing"
                          value={newAsset.batteryCasing}
                          onChange={handleChange}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.batteryLocation")}
                          explanation={t(
                            "createAsset.placeholders.batteryLocationExplanation"
                          )}
                          type="text"
                          maxLength={50}
                          name="battery_location"
                          value={newAsset.battery_location}
                          onChange={handleChange}
                          placeholder={t(
                            "createAsset.placeholders.batteryLocationPlaceholder"
                          )}
                          className="p-2 border border-gray-300 gap-2"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Charger Information Section */}
                  <div className="bg-white   mt-4">
                    <h4 className="font-medium mb-3 text-gray-800">
                      {t("createAsset.placeholders.chargerInformation")}
                    </h4>

                    {/* Row 1: Charger Manufacturer, Charger Type, Charger Model, Nominal Voltage, AMP */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-2 mb-2">
                      <div className="flex flex-col">
                        <InputField
                          label={t(
                            "createAsset.placeholders.chargerManufacturer"
                          )}
                          explanation={t(
                            "createAsset.placeholders.chargerManufacturerExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerManufacturerPlaceholder"
                          )}
                          type="text"
                          name="chargerManufacturer"
                          value={newAsset.chargerManufacturer}
                          onChange={handleChange}
                          maxLength={100}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <SelectField
                          name="chargerLoadertype"
                          value={newAsset.chargerLoadertype}
                          onChange={handleChange}
                          label={t("createAsset.placeholders.chargerTypeLabel")}
                          explanation={t(
                            "createAsset.placeholders.chargerTypeExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerTypePlaceholder"
                          )}
                          menus={[
                            {
                              value: 1,
                              option: t(
                                "createAsset.placeholders.chargerTypeExplanation"
                              ),
                            },
                            {
                              value: 1,
                              option: t("assets.options.single-phase"),
                            },
                            {
                              value: 2,
                              option: t("assets.options.three-phase"),
                            },
                            { value: 3, option: t("assets.options.hf") },
                            { value: 4, option: t("assets.options.modular") },
                            {
                              value: 5,
                              option: t("assets.options.opportunity"),
                            },
                            { value: 6, option: t("assets.options.li-ferro") },
                            { value: 7, option: t("assets.options.scr") },
                            {
                              value: 8,
                              option: t("assets.options.charger_others"),
                            },
                          ]}
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.chargerModel")}
                          explanation={t(
                            "createAsset.placeholders.chargerModelExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerModelPlaceholder"
                          )}
                          type="text"
                          name="chargerModel"
                          value={newAsset.chargerModel}
                          maxLength={100}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={
                            t("createAsset.placeholders.chargerNominalVoltage")
                              .length > 12
                              ? t(
                                  "createAsset.placeholders.chargerNominalVoltage"
                                ).slice(0, 12) + " ..."
                              : t(
                                  "createAsset.placeholders.chargerNominalVoltage"
                                )
                          }
                          explanation={t(
                            "createAsset.placeholders.chargerNominalVoltageExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerNominalVoltagePlaceholder"
                          )}
                          type="number"
                          name="chargerAC"
                          value={newAsset.chargerAC}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={t("createAsset.placeholders.chargerAMP")}
                          explanation={t(
                            "createAsset.placeholders.chargerAMPExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerAMPPlaceholder"
                          )}
                          type="number"
                          name="chargerCurrent"
                          value={newAsset.chargerCurrent}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div className="flex flex-col">
                        <InputField
                          label={
                            t("createAsset.placeholders.chargerACVoltage")
                              .length > 12
                              ? t(
                                  "createAsset.placeholders.chargerACVoltage"
                                ).slice(0, 12) + " ..."
                              : t("createAsset.placeholders.chargerACVoltage")
                          }
                          explanation={t(
                            "createAsset.placeholders.chargerACVoltageExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerACVoltagePlaceholder"
                          )}
                          type="number"
                          name="chargerVoltage"
                          value={newAsset.chargerVoltage}
                          maxLength={50}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div className="flex flex-col">
                        <InputField
                          label={
                            t("createAsset.placeholders.chargerYOM").length > 12
                              ? t("createAsset.placeholders.chargerYOM").slice(
                                  0,
                                  12
                                ) + " ..."
                              : t("createAsset.placeholders.chargerYOM")
                          }
                          explanation={t(
                            "createAsset.placeholders.chargerYOMExplanation"
                          )}
                          placeholder={t(
                            "createAsset.placeholders.chargerYOMPlaceholder"
                          )}
                          type="month"
                          name="charger_yom"
                          value={newAsset.charger_yom}
                          onChange={handleChange}
                          className="px-4 py-2 border border-gray-300 gap-2-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>

                    {/* Row 2: AC Voltage, Year of Manufacture (2 fields only) */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
                      {/* Empty columns to maintain 5-column grid */}
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>

                    {/* Battery Description (spans full width) */}
                    <div className="mb-6">
                      <TextAreaField
                        name="battery_description"
                        value={newAsset.battery_description}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.batteryDescription")}
                        explanation={t(
                          "createAsset.placeholders.batteryDescriptionPlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.batteryDescriptionExplanation"
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-white p-4 shadow-md">
                  <h3 className="text-lg font-semibold text-gray-800 mb-6">
                    {t("assetPageHeadings.tires")}
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
                    <div>
                      <SelectField
                        name="tire_type"
                        value={newAsset.tire_type}
                        onChange={handleChange}
                        // label={t("assets.create.fields.tiresFront")}
                        label={t("createAsset.placeholders.tireType")}
                        explanation={t(
                          "createAsset.placeholders.tireTypeExplanation"
                        )}
                        menus={[
                          {
                            value: 0,
                            option: t("assets.fields.tireTypes.unknown"),
                          },
                          {
                            value: 1,
                            option: t("assets.fields.tireTypes.cushion"),
                          },
                          {
                            value: 2,
                            option: t("assets.fields.tireTypes.pneumatic"),
                          },
                          {
                            value: 3,
                            option: t("assets.fields.tireTypes.polyurethane"),
                          },
                          {
                            value: 4,
                            option: t("assets.fields.tireTypes.superelastic"),
                          },
                          {
                            value: 5,
                            option: t("assets.fields.tireTypes.solidrubber"),
                          },
                          { value: 6, option: "Vulkollan" },
                        ]}
                      />
                    </div>

                    <div>
                      <InputField
                        name="front_tires"
                        type="number"
                        value={newAsset.front_tires}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.frontTires")}
                        explanation={t(
                          "createAsset.placeholders.frontTiresExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.fronteTiresPlaceholder"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="front_tire_size"
                        type="number"
                        value={newAsset.front_tire_size}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.frontTireSize")}
                        explanation={t(
                          "createAsset.placeholders.frontTireSizePlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.frontTireSizeExplanation"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rear_tires"
                        type="number"
                        value={newAsset.rear_tires}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.rearTires")}
                        explanation={t(
                          "createAsset.placeholders.rearTiresExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rearTiresPlaceholder"
                        )}
                      />
                    </div>

                    <div>
                      <InputField
                        name="rear_tire_size"
                        type="number"
                        value={newAsset.rear_tire_size}
                        onChange={handleChange}
                        maxLength={50}
                        label={t("createAsset.placeholders.rearTireSize")}
                        explanation={t(
                          "createAsset.placeholders.rearTireSizePlaceholder"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rearTireSizeExplanation"
                        )}
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <TextAreaField
                      name="tire_description"
                      value={newAsset.tire_description}
                      onChange={handleChange}
                      label={t("createAsset.placeholders.tireDescription")}
                      explanation={t(
                        "createAsset.placeholders.tireDescriptionExplanation"
                      )}
                      placeholder={t(
                        "createAsset.placeholders.tireDescriptionPlaceholder"
                      )}
                    />
                  </div>
                </div>

                <div className="bg-white p-4 shadow-md  ">
                  <h2 className="text-xl font-medium mb-3   text-gray-800">
                    {t("assetPageHeadings.media")}
                  </h2>

                  {selectedFiles?.length > 0 && (
                    <div className="space-y-2 mt-2">
                      {/* <h4 className=" text-gray-700">Selected Files</h4> */}
                      <h6>{t("assetPageHeadings.selectedMedia")} </h6>
                      <ul className="space-y-1 flex flex-col gap-3">
                        {Array.from(selectedFiles).map((file, index) => (
                          <li key={index} className="flex items-center gap-4">
                            {file.type.startsWith("image/") && (
                              <img
                                className="h-10 w-10"
                                alt={`asset image  ${index}`}
                                src={URL.createObjectURL(file)}
                              />
                            )}
                            <a
                              href={URL.createObjectURL(file)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 text-sm font-semibold underline ml-2"
                            >
                              {file.name}
                            </a>
                            <div
                              onClick={() => handleRemoveFile(index)}
                              className="cursor-pointer"
                            >
                              <X className="h-5 w-5 " />
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {assetAttachments &&
                    Array.isArray(assetAttachments) &&
                    assetAttachments?.length > 0 && (
                      <div className="flex flex-col gap-2">
                        <h6 className="mt-4">
                          {t("assetPageHeadings.uploadedMedia")}{" "}
                        </h6>
                        {
                          <div className="flex flex-col gap-3">
                            {assetAttachments.map((attachment, index) => {
                              if (attachment?.image) {
                                return (
                                  <div
                                    key={index}
                                    className="flex items-center gap-2"
                                  >
                                    {
                                      <img
                                        className="h-10 w-10"
                                        alt={`asset image  ${index}`}
                                        src={getAttachmentThumbUrl(attachment)}
                                      />
                                    }
                                    <a
                                      href={getAttachmentLargeUrl(attachment)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className=" text-blue-600 text-sm font-semibold underline ml-2"
                                    >
                                      {formatAttachment(
                                        getAttachmentLargeUrl(attachment)
                                      )}
                                    </a>
                                    <div
                                      onClick={() => {
                                        handleDeleteAttachment(attachment?.id);
                                      }}
                                      className="cursor-pointer "
                                    >
                                      <X className="Cursor-pointer h-5 w-5 " />
                                    </div>
                                  </div>
                                );
                              } else if (attachment?.document) {
                                return (
                                  <div className="flex items-center gap-4  ">
                                    <a
                                      href={getAttachmentDocumentUrl(attachment)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className=" text-blue-600 text-sm font-semibold underline ml-2"
                                    >
                                      {formatAttachment(
                                        getAttachmentDocumentUrl(attachment)
                                      )}
                                    </a>
                                    <div
                                      onClick={() => {
                                        handleDeleteAttachment(attachment?.id);
                                      }}
                                      className="cursor-pointer"
                                    >
                                      <X className="Cursor-pointer h-5 w-5" />
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        }
                      </div>
                    )}
                  <div className="my-4">
                    <div className="relative">
                      <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        accept="image/*, .xlsx, .xls, .doc, .docx, .pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/pdf"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                        id="image-upload"
                      />
                      <label
                        htmlFor="image-upload"
                        className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 hover:border-gray-400 transition-all duration-200 ease-in-out group"
                      >
                        {/* Upload Icon Only */}
                        <Upload className="w-8 h-8 text-gray-400 group-hover:text-gray-600 transition-colors" />

                        {/* File Type Info */}
                        <p className="mt-2 text-xs text-gray-400 group-hover:text-gray-600 transition-colors">
                          {t("assetPageHeadings.fileSupported")}
                        </p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {selectedCategory === "Attachments" && (
              <Attachments
                formatAttachment={formatAttachment}
                handleDeleteAttachment={handleDeleteAttachment}
                assetAttachments={assetAttachments}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                warehouseLocationId={warehouseLocationId}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Lift Masts" && (
              <LiftMasts
                formatAttachment={formatAttachment}
                handleDeleteAttachment={handleDeleteAttachment}
                assetAttachments={assetAttachments}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                warehouseLocationId={warehouseLocationId}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Work Platforms" && (
              <WorkPlatforms
                formatAttachment={formatAttachment}
                handleDeleteAttachment={handleDeleteAttachment}
                assetAttachments={assetAttachments}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                warehouseLocationId={warehouseLocationId}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Cleaning Equipment" && (
              <CleaningEquipment
                formatAttachment={formatAttachment}
                handleDeleteAttachment={handleDeleteAttachment}
                assetAttachments={assetAttachments}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                warehouseLocationId={warehouseLocationId}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Spare Parts" && (
              <SpareParts
                formatAttachment={formatAttachment}
                handleDeleteAttachment={handleDeleteAttachment}
                assetAttachments={assetAttachments}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                warehouseLocationId={warehouseLocationId}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
            {selectedCategory === "Construction Machinery" && (
              <ConstructionMachinery
                formatAttachment={formatAttachment}
                handleDeleteAttachment={handleDeleteAttachment}
                assetAttachments={assetAttachments}
                newAsset={newAsset}
                handleChange={handleChange}
                warehouses={warehouses}
                selectedWarehouse={selectedWarehouse}
                handleWarehouseChange={handleWarehouseChange}
                warehouseLocationId={warehouseLocationId}
                selectedFiles={selectedFiles}
                handleRemoveFile={handleRemoveFile}
                handleFileChange={handleFileChange}
              />
            )}
          </>
        )}
        {currentStep === 1 && (
          <>
            {(selectedCategory === "Forklifts" ||
              selectedCategory === "Chargers") && (
              <>
                <div className="mb-6 bg-white p-4 shadow-md">
                  <h3 className="text-lg font-semibold  text-gray-700 mb-4">
                    {t("assetPageHeadings.pricingInformation")}
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                    <div>
                      <InputField
                        name="end_user_price"
                        type="number"
                        step="0.01"
                        value={newAsset.end_user_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.endUserPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.endUserPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.endUserPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    <div>
                      <InputField
                        name="dealer_price"
                        type="number"
                        step="0.01"
                        value={newAsset.dealer_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.dealerPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.dealerPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.dealerPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    <div>
                      <InputField
                        name="internal_price"
                        type="number"
                        step="0.01"
                        value={newAsset.internal_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.internalPriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.internalPriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.internalPricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    {/* <div>
                <InputField
                  name="intranet_price"
                  type="number"
                  step="0.01"
                  value={newAsset.intranet_price}
                  onChange={handleChange}
                  label={t("createAsset.placeholders.intranetPriceLabel")}
                  explanation={t(
                    "createAsset.placeholders.intranetPriceExplanation"
                  )}
                  placeholder={t(
                    "createAsset.placeholders.intranetPricePlaceholder"
                  )}
                  maxLength={12}
                />
              </div> */}

                    <div className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-2 flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0 w-full">
                      <span className="text-sm font-medium text-gray-700">
                        {t("createAsset.placeholders.publishTo")}
                      </span>

                      <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            name="publish_mascus"
                            checked={newAsset.publish_mascus || false}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="text-sm text-gray-700">Mascus</span>
                        </label>

                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            name="publish_supralift"
                            checked={newAsset.publish_supralift || false}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="text-sm text-gray-700">
                            Supralift
                          </span>
                        </label>

                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            name="publish_forklift"
                            checked={newAsset.publish_forklift || false}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="text-sm text-gray-700">
                            Forklift
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Rental Pricing Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("assetPageHeadings.rentingPriceInformation")}
                  </h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    <div>
                      <InputField
                        name="rental_price_daily"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_daily}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceDailyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceDailyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceDailyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    <div>
                      <InputField
                        name="rental_price_weekly"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_weekly}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceWeeklyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceWeeklyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceWeeklyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    <div>
                      <InputField
                        name="rental_price_monthly"
                        type="number"
                        step="0.01"
                        value={newAsset.rental_price_monthly}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.rentalPriceMonthlyLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.rentalPriceMonthlyExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.rentalPriceMonthlyPlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                  </div>
                </div>

                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("createAsset.placeholders.purchaseInformation")}
                  </h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    <div>
                      <InputField
                        name="purchase_price"
                        type="number"
                        step="0.01"
                        value={newAsset.purchase_price}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.purchasePriceLabel")}
                        explanation={t(
                          "createAsset.placeholders.purchasePriceExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.purchasePricePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                    <div>
                      <InputField
                        name="purchase_date"
                        type="date"
                        value={newAsset.purchase_date || ""}
                        onChange={handleChange}
                        label={t(
                          "createAsset.placeholders.dateOfPurchaseLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.dateOfPurchaseExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="book_value"
                        type="number"
                        step="0.01"
                        value={newAsset.book_value}
                        onChange={handleChange}
                        label={t("createAsset.placeholders.bookValueLabel")}
                        explanation={t(
                          "createAsset.placeholders.bookValueExplanation"
                        )}
                        placeholder={t(
                          "createAsset.placeholders.bookValuePlaceholder"
                        )}
                        maxLength={12}
                      />
                    </div>
                  </div>
                </div>

                {/* Book Value History Section */}
                {/*  */}

                <BookValueHistory t={t} id={id} />

                {/* Remarks Section */}
                <div className="mb-8 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium text-gray-700 mb-4">
                    {t("createAsset.placeholders.Remarks")}
                  </h4>
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("createAsset.placeholders.internalRemark")}
                      </label>
                      <textarea
                        name="internal_remark"
                        value={newAsset.internal_remark || ""}
                        onChange={handleChange}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
                        placeholder={t(
                          "createAsset.placeholders.internalRemarkPlaceholder"
                        )}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {t("createAsset.placeholders.internalRemarkForAsset")}
                      </p>
                    </div>
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("createAsset.placeholders.intranetRemarks")}
                      </label>
                      <textarea
                        name="intranet_remark"
                        value={newAsset.intranet_remark || ""}
                        onChange={handleChange}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
                        placeholder={t(
                          "createAsset.placeholders.intranetRemarksPlaceholder"
                        )}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {t("createAsset.placeholders.intranetRemarksForAsset")}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            {selectedCategory === "Batteries" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                showPublish={true}
                id={id}
              />
              // <>
              //   <div className="mb-6 bg-white p-4 shadow-md">
              //     <h3 className="text-lg font-semibold  text-gray-700 mb-4">
              //       {t("assetPageHeadings.pricingInformation")}
              //     </h3>
              //     <div className="grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-5 gap-3">
              //       <div>
              //         <InputField
              //           name="end_user_price"
              //           type="number"
              //           step="0.01"
              //           value={newAsset.end_user_price}
              //           onChange={handleChange}
              //           label={t("createAsset.placeholders.endUserPriceLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.endUserPriceExplanation"
              //           )}
              //           placeholder={t(
              //             "createAsset.placeholders.endUserPricePlaceholder"
              //           )}
              //           maxLength={12}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="dealer_price"
              //           type="number"
              //           step="0.01"
              //           value={newAsset.dealer_price}
              //           onChange={handleChange}
              //           label={t("createAsset.placeholders.dealerPriceLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.dealerPriceExplanation"
              //           )}
              //           placeholder={t(
              //             "createAsset.placeholders.dealerPricePlaceholder"
              //           )}
              //           maxLength={12}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="internal_price"
              //           type="number"
              //           step="0.01"
              //           value={newAsset.internal_price}
              //           onChange={handleChange}
              //           label={t("createAsset.placeholders.internalPriceLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.internalPriceExplanation"
              //           )}
              //           placeholder={t(
              //             "createAsset.placeholders.internalPricePlaceholder"
              //           )}
              //           maxLength={12}
              //         />
              //       </div>
              //       {/* <div>
              //   <InputField
              //     name="intranet_price"
              //     type="number"
              //     step="0.01"
              //     value={newAsset.intranet_price}
              //     onChange={handleChange}
              //     label={t("createAsset.placeholders.intranetPriceLabel")}
              //     explanation={t(
              //       "createAsset.placeholders.intranetPriceExplanation"
              //     )}
              //     placeholder={t(
              //       "createAsset.placeholders.intranetPricePlaceholder"
              //     )}
              //     maxLength={12}
              //   />
              // </div> */}

              //       <div className="col-span-2 flex items-center space-x-4  w-full ">
              //         <span className="text-sm font-medium text-gray-700">
              //           {t("createAsset.placeholders.publishTo")}
              //         </span>

              //         <label className="flex items-center space-x-1">
              //           <input
              //             type="checkbox"
              //             name="publish_mascus"
              //             checked={newAsset.publish_mascus || false}
              //             onChange={handleChange}
              //             className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              //           />
              //           <span className="text-sm text-gray-700">Mascus</span>
              //         </label>

              //         <label className="flex items-center space-x-1">
              //           <input
              //             type="checkbox"
              //             name="publish_supralift"
              //             checked={newAsset.publish_supralift || false}
              //             onChange={handleChange}
              //             className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              //           />
              //           <span className="text-sm text-gray-700">Supralift</span>
              //         </label>

              //         <label className="flex items-center space-x-1">
              //           <input
              //             type="checkbox"
              //             name="publish_forklift"
              //             checked={newAsset.publish_forklift || false}
              //             onChange={handleChange}
              //             className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              //           />
              //           <span className="text-sm text-gray-700">Forklift</span>
              //         </label>
              //       </div>
              //     </div>
              //   </div>
              // </>
            )}
            {selectedCategory === "Attachments" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                showPublish={true}
                id={id}
              />
            )}
            {selectedCategory === "Lift Masts" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                showPublish={true}
                id={id}
              />
            )}
            {selectedCategory === "Work Platforms" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                showPublish={true}
                id={id}
              />
            )}
            {selectedCategory === "Cleaning Equipment" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                showPublish={true}
                id={id}
              />
            )}
            {selectedCategory === "Spare Parts" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                showPublish={true}
                id={id}
              />
            )}
            {selectedCategory === "Construction Machinery" && (
              <FinancialInfoSection
                t={t}
                newAsset={newAsset}
                handleChange={handleChange}
                showPublish={true}
                id={id}
              />
            )}
          </>
        )}
        {currentStep === 2 && (
          <>
            {(selectedCategory === "Forklifts" ||
              selectedCategory === "Chargers") && (
              <div className="mb-8">
                {/* Contract Information */}
                <div className="mb-6 bg-white p-4 shadow-md">
                  <h4 className="text-md font-medium mb-2 text-gray-700">
                    {t("assetPageHeadings.contractInformation")}
                  </h4>

                  {/* Contract Details Row - Improved Responsiveness */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-2  mb-2">
                    <div>
                      <SelectField
                        name="contract_type"
                        value={contractForm.contract_type}
                        onChange={handleContractChange}
                        label={t("createAsset.placeholders.contractLabel")}
                        required
                        explanation={t(
                          "createAsset.placeholders.contractExplanation"
                        )}
                        menus={[
                          {
                            value: "",
                            option: t(
                              "createAsset.placeholders.contractExplanation"
                            ),
                          },
                          { value: "demo", option: t("assets.options.demo") },
                          {
                            value: "rental",
                            option: t("assets.options.rental"),
                          },
                          {
                            value: "leasing",
                            option: t("assets.options.leasing"),
                          },
                          { value: "sale", option: t("assets.options.sale") },
                          {
                            value: "maintenance",
                            option: t("assets.options.maintenance"),
                          },
                        ]}
                      />
                    </div>
                    <div>
                      <InputField
                        type="date"
                        name="contract_start"
                        value={contractForm.contract_start}
                        onChange={handleContractChange}
                        label={t("createAsset.placeholders.contractStartLabel")}
                        explanation={t(
                          "createAsset.placeholders.contractStartExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_end"
                        type="date"
                        value={contractForm.contract_end}
                        onChange={handleContractChange}
                        label={t("createAsset.placeholders.contractEndLabel")}
                        explanation={t(
                          "createAsset.placeholders.contractEndExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="contract_price_euro"
                        type="number"
                        step="0.01"
                        min="0"
                        value={contractForm.contract_price_euro}
                        onChange={handleContractChange}
                        maxLength={12}
                        label={t("createAsset.placeholders.contractPrice")}
                        placeholder={t(
                          "createAsset.placeholders.contractPricePlaceholder"
                        )}
                        explanation={t(
                          "createAsset.placeholders.contractPriceExplanation"
                        )}
                      />
                    </div>
                  </div>

                  {/* Customer Contact Information Row - Improved Responsiveness */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-2 mb-2">
                    <div>
                      <InputField
                        name="customer_company"
                        required
                        type="text"
                        maxLength={50}
                        value={contractForm?.customer.customer_company || ""}
                        onChange={handleContractChange}
                        placeholder={t(
                          "createAsset.placeholders.companyPlaceholder"
                        )}
                        label={t("createAsset.placeholders.companyLabel")}
                        explanation={t(
                          "createAsset.placeholders.companyExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="name"
                        type="text"
                        required
                        maxLength={50}
                        value={contractForm?.customer.name}
                        onChange={handleContractChange}
                        placeholder={t(
                          "createAsset.placeholders.contactPersonPlaceholder"
                        )}
                        label={t("createAsset.placeholders.contactPersonLabel")}
                        explanation={t(
                          "createAsset.placeholders.contactPersonExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="phone_number"
                        required
                        type="tel"
                        maxLength={20}
                        value={contractForm?.customer.phone_number}
                        onChange={handleContractChange}
                        placeholder={t(
                          "createAsset.placeholders.phonePlaceholder"
                        )}
                        label={t("createAsset.placeholders.phoneLabel")}
                        explanation={t(
                          "createAsset.placeholders.phoneExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="email"
                        type="email"
                        maxLength={100}
                        value={contractForm?.customer.email}
                        onChange={handleContractChange}
                        placeholder={t(
                          "createAsset.placeholders.emailPlaceholder"
                        )}
                        label={t("createAsset.placeholders.emailLabel")}
                        explanation={t(
                          "createAsset.placeholders.emailExplanation"
                        )}
                      />
                    </div>
                    <div>
                      <InputField
                        name="customer_number"
                        type="text"
                        maxLength={20}
                        value={contractForm?.customer?.customer_number || ""}
                        onChange={handleContractChange}
                        placeholder={t(
                          "createAsset.placeholders.customerNumberPlaceholder"
                        )}
                        label={t(
                          "createAsset.placeholders.customerNumberLabel"
                        )}
                        explanation={t(
                          "createAsset.placeholders.customerNumberExplanation"
                        )}
                      />
                    </div>
                  </div>

                  {/* Invoice Address Section - Improved Responsiveness */}
                  <div className="mb-6">
                    <h5 className="text-sm font-medium mb-3 text-gray-600">
                      {t("createAsset.placeholders.InvoiceAddress")}
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-2">
                      {Array.isArray(warehouses) && warehouses?.length > 0 && (
                        <div className="col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2">
                          <SelectField
                            name="warehouse"
                            value={selectedContractWarehouse?.id || ""}
                            onChange={handleWarehouseChange2}
                            label={t("createAsset.placeholders.warehouseLabel")}
                            explanation={t(
                              "createAsset.placeholders.warehouseExplanation"
                            )}
                            placeholder={t(
                              "createAsset.placeholders.warehousePlaceholder"
                            )}
                            menus={[
                              {
                                value: "",
                                option: t(
                                  "createAsset.placeholders.warehousePlaceholder"
                                ),
                              },
                              ...warehouses.map((warehouse) => ({
                                value: warehouse.id,
                                option: warehouse.name,
                              })),
                            ]}
                          />
                        </div>
                      )}
                      <div className="col-span-1">
                        <InputField
                          name="invoice_address_street"
                          type="text"
                          maxLength={20}
                          value={contractForm?.invoice_address_street || ""}
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.streetPlaceholder"
                          )}
                          label={t("createAsset.placeholders.streetLabel")}
                          explanation={t(
                            "createAsset.placeholders.streetExplanation"
                          )}
                        />
                      </div>
                      <div className="col-span-1">
                        <InputField
                          name="invoice_address_city"
                          type="text"
                          maxLength={20}
                          value={contractForm?.invoice_address_city || ""}
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.cityPlaceholder"
                          )}
                          label={t("createAsset.placeholders.cityLabel")}
                          explanation={t(
                            "createAsset.placeholders.cityExplanation"
                          )}
                        />
                      </div>
                      <div className="col-span-1">
                        <InputField
                          name="invoice_address_country"
                          type="text"
                          maxLength={20}
                          value={contractForm?.invoice_address_country || ""}
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.countryPlaceholder"
                          )}
                          label={t("createAsset.placeholders.countryLabel")}
                          explanation={t(
                            "createAsset.placeholders.countryExplanation"
                          )}
                        />
                      </div>
                      <div className="col-span-1">
                        <InputField
                          name="invoice_address_zip"
                          type="text"
                          maxLength={7}
                          value={contractForm?.invoice_address_zip || ""}
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.zipPlaceholder"
                          )}
                          label={t("createAsset.placeholders.zipLabel")}
                          explanation={t(
                            "createAsset.placeholders.zipExplanation"
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Delivery Address Section - Improved Responsiveness */}
                  <div className="mb-4">
                    <h5 className="text-sm font-medium mb-3 text-gray-600">
                      {t("createAsset.placeholders.deliveryAddress")}
                    </h5>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-2 items-end">
                      {/* Checkbox - Full width on mobile, spans 2 cols on larger screens */}
                      <div className="col-span-1 sm:col-span-2 md:col-span-1 lg:col-span-1">
                        <label className="flex items-center h-10">
                          <input
                            type="checkbox"
                            name=""
                            checked={checboxValue}
                            onChange={handleCheckboxToggle}
                            className="mr-2"
                          />
                          <span className="text-sm text-gray-700">
                            {t("createAsset.placeholders.sameAsInvoice")}
                          </span>
                        </label>
                      </div>

                      {/* Address fields */}
                      <div className="col-span-1">
                        <InputField
                          disabled={checboxValue}
                          name="delivery_address_street"
                          type="text"
                          maxLength={20}
                          value={
                            checboxValue
                              ? contractForm?.invoice_address_street
                              : contractForm?.delivery_address_street
                          }
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.streetPlaceholder"
                          )}
                          label={t("createAsset.placeholders.streetLabel")}
                          explanation={t(
                            "createAsset.placeholders.streetExplanation"
                          )}
                        />
                      </div>

                      <div className="col-span-1">
                        <InputField
                          disabled={checboxValue}
                          name="delivery_address_city"
                          type="text"
                          maxLength={20}
                          value={
                            checboxValue
                              ? contractForm?.invoice_address_city
                              : contractForm?.delivery_address_city
                          }
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.cityPlaceholder"
                          )}
                          label={t("createAsset.placeholders.cityLabel")}
                          explanation={t(
                            "createAsset.placeholders.cityExplanation"
                          )}
                        />
                      </div>

                      <div className="col-span-1">
                        <InputField
                          disabled={checboxValue}
                          name="delivery_address_country"
                          type="text"
                          maxLength={20}
                          value={
                            checboxValue
                              ? contractForm?.invoice_address_country
                              : contractForm?.delivery_address_country
                          }
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.countryPlaceholder"
                          )}
                          label={t("createAsset.placeholders.countryLabel")}
                          explanation={t(
                            "createAsset.placeholders.countryExplanation"
                          )}
                        />
                      </div>

                      <div className="col-span-1">
                        <InputField
                          disabled={checboxValue}
                          name="delivery_address_zip"
                          type="text"
                          maxLength={7}
                          value={
                            checboxValue
                              ? contractForm?.invoice_address_zip
                              : contractForm?.delivery_address_zip
                          }
                          onChange={handleContractChange}
                          placeholder={t(
                            "createAsset.placeholders.zipPlaceholder"
                          )}
                          label={t("createAsset.placeholders.zipLabel")}
                          explanation={t(
                            "createAsset.placeholders.zipExplanation"
                          )}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-2 mb-3 mt-4">
                      <div className="lg:col-span-4">
                        <div className="flex items-center gap-2">
                          {/* <span className="text-md font-medium text-gray-700">
                            {t("createAsset.placeholders.transportUrlLabel") ||
                              "Transport Order URL"}
                            :
                          </span> */}
                          {/* {transportUrl && isValidUrl(transportUrl) ? (
                            <a
                              href={normalizedTransportUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:underline break-all"
                              title={normalizedTransportUrl}
                            >
                              {transportUrl}
                            </a>
                          ) : (
                            <span className="text-gray-500">
                              {t("common.notSet") || "Not set"}
                            </span>
                          )} */}
                          {/* {transportUrl && isValidUrl(transportUrl) && (
                            <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-2 mb-3 mt-4">
                              <div className="lg:col-span-4">
                                <div className="flex items-center gap-2">
                                  <span className="text-md font-medium text-gray-700">
                                    {t(
                                      "createAsset.placeholders.transportUrlLabel"
                                    ) || "Transport Order URL"}
                                    :
                                  </span>
                                  <a
                                    href={normalizedTransportUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:underline break-all"
                                    title={normalizedTransportUrl}
                                  >
                                    {transportUrl}
                                  </a>
                                </div>
                              </div>
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* History Log Section */}
                <ContractHistoryTable
                  t={t}
                  id={id}
                  refreshContracts={refreshContracts}
                  transportUrl={transportUrl}
                  isValidUrl={isValidUrl}
                />
                {/* <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span className="fw-semibold">Transport Order URL</span>
                  {transportUrl && isValidUrl(transportUrl) ? (
                    <>
                      <a
                        href={normalizedTransportUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary text-truncate"
                        style={{ maxWidth: "320px" }}
                        title={normalizedTransportUrl}
                      >
                        {transportUrl}
                      </a>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handleCopyTransportUrl}
                        aria-label="Copy transport order URL"
                      >
                        Copy
                      </button>
                    </>
                  ) : (
                    <span className="text-muted">Not set</span>
                  )}
                </div> */}
              </div>
            )}

            {selectedCategory === "Batteries" && (
              <>
                <ContractInfoSection
                  t={t}
                  contractForm={contractForm}
                  handleChange={handleContractChange}
                  warehouses={warehouses}
                  selectedContractWarehouse={selectedContractWarehouse}
                  handleWarehouseChange2={handleWarehouseChange2}
                  checboxValue={checboxValue}
                  handleCheckboxToggle={handleCheckboxToggle}
                  id={id}
                  refreshContracts={refreshContracts}
                  transportUrl={transportUrl}
                  isValidUrl={isValidUrl}
                  normalizedTransportUrl={normalizedTransportUrl}
                />
                {/* <ContractHistoryTable
                t={t}
                id={id}
                refreshContracts={refreshContracts} */}
                {/* /> */}
              </>
              // <div className="mb-8 ">
              //   {/* Customer Details */}

              //   {/* Contract Information */}
              //   <div className="mb-6 bg-white p-4 shadow-md">
              //     <h4 className="text-md font-medium mb-3 text-gray-700">
              //       {t("assetPageHeadings.contractInformation")}
              //     </h4>

              //     {/* Contract Details Row */}
              //     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-2 mb-2">
              //       <div>
              //         <SelectField
              //           name="contract_type"
              //           value={newAsset.contract_type}
              //           onChange={handleChange}
              //           label={t("createAsset.placeholders.contractLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.contractExplanation"
              //           )}
              //           menus={[
              //             { value: "", option: "Select Contract Type" },
              //             { value: "demo", option: "Demo" },
              //             { value: "rental", option: "Rental" },
              //             { value: "leasing", option: "Leasing" },
              //             { value: "sale", option: "Sale" },
              //           ]}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="contract_start"
              //           type="date"
              //           value={newAsset.contract_start}
              //           onChange={handleChange}
              //           label="Start "
              //           explanation={t(
              //             "createAsset.placeholders.contractStartExplanation"
              //           )}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="contract_end"
              //           type="date"
              //           value={newAsset.contract_end}
              //           onChange={handleChange}
              //           label="End "
              //           explanation={t(
              //             "createAsset.placeholders.contractEndExplanation"
              //           )}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="contract_price_euro"
              //           type="number"
              //           step="0.01"
              //           min="0"
              //           value={newAsset.contract_price_euro}
              //           onChange={handleChange}
              //           maxLength={12}
              //           label="Preis"
              //           placeholder={t(
              //             "createAsset.placeholders.contractPricePlaceholder"
              //           )}
              //           explanation={t(
              //             "createAsset.placeholders.contractPriceExplanation"
              //           )}
              //         />
              //       </div>
              //     </div>

              //     {/* Customer Contact Information Row */}
              //     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-x-2 mb-2">
              //       <div>
              //         <InputField
              //           name="customer_company"
              //           type="text"
              //           maxLength={50}
              //           value={newAsset.customer_company}
              //           onChange={handleChange}
              //           placeholder={t(
              //             "createAsset.placeholders.companyPlaceholder"
              //           )}
              //           label={t("createAsset.placeholders.companyLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.companyExplanation"
              //           )}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="customer_contact_name"
              //           type="text"
              //           maxLength={50}
              //           value={newAsset.customer_contact_name}
              //           onChange={handleChange}
              //           placeholder={t(
              //             "createAsset.placeholders.contactPersonPlaceholder"
              //           )}
              //           label={t("createAsset.placeholders.contactPersonLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.contactPersonExplanation"
              //           )}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="customer_phone"
              //           type="tel"
              //           maxLength={20}
              //           value={newAsset.customer_phone}
              //           onChange={handleChange}
              //           placeholder={t(
              //             "createAsset.placeholders.phonePlaceholder"
              //           )}
              //           label={t("createAsset.placeholders.phoneLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.phoneExplanation"
              //           )}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="customer_email"
              //           type="email"
              //           maxLength={100}
              //           value={newAsset.customer_email}
              //           onChange={handleChange}
              //           placeholder={t(
              //             "createAsset.placeholders.emailPlaceholder"
              //           )}
              //           label={t("createAsset.placeholders.emailLabel")}
              //           explanation={t(
              //             "createAsset.placeholders.emailExplanation"
              //           )}
              //         />
              //       </div>
              //       <div>
              //         <InputField
              //           name="customer_number"
              //           type="text"
              //           maxLength={20}
              //           value={newAsset.customer_number}
              //           onChange={handleChange}
              //           placeholder={t(
              //             "createAsset.placeholders.customerNumberPlaceholder"
              //           )}
              //           label={t(
              //             "createAsset.placeholders.customerNumberLabel"
              //           )}
              //           explanation={t(
              //             "createAsset.placeholders.customerNumberExplanation"
              //           )}
              //         />
              //       </div>
              //     </div>

              //     {/* Invoice Address Section */}
              //     <div className="mb-4">
              //       <h5 className="text-sm font-medium mb-2 text-gray-600">
              //         {t("createAsset.placeholders.InvoiceAddress")}
              //       </h5>
              //       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-x-2">
              //         <div>
              //           <InputField
              //             name="invoice_address_street"
              //             type="text"
              //             maxLength={100}
              //             value={newAsset.invoice_address_street}
              //             onChange={handleChange}
              //             placeholder={t(
              //               "createAsset.placeholders.streetPlaceholder"
              //             )}
              //             label={t("createAsset.placeholders.streetLabel")}
              //             explanation={t(
              //               "createAsset.placeholders.streetExplanation"
              //             )}
              //           />
              //         </div>
              //         <div>
              //           <InputField
              //             name="invoice_address_zip"
              //             type="text"
              //             maxLength={20}
              //             value={newAsset.invoice_address_zip}
              //             onChange={handleChange}
              //             placeholder={t(
              //               "createAsset.placeholders.zipPlaceholder"
              //             )}
              //             label={t("createAsset.placeholders.zipLabel")}
              //             explanation={t(
              //               "createAsset.placeholders.zipExplanation"
              //             )}
              //           />
              //         </div>
              //         <div>
              //           <InputField
              //             name="invoice_address_city"
              //             type="text"
              //             maxLength={50}
              //             value={newAsset.invoice_address_city}
              //             onChange={handleChange}
              //             placeholder={t(
              //               "createAsset.placeholders.cityPlaceholder"
              //             )}
              //             label={t("createAsset.placeholders.cityLabel")}
              //             explanation={t(
              //               "createAsset.placeholders.cityExplanation"
              //             )}
              //           />
              //         </div>
              //         <div>
              //           <InputField
              //             name="invoice_address_country"
              //             type="text"
              //             maxLength={50}
              //             value={newAsset.invoice_address_country}
              //             onChange={handleChange}
              //             placeholder={t(
              //               "createAsset.placeholders.countryPlaceholder"
              //             )}
              //             label={t("createAsset.placeholders.countryLabel")}
              //             explanation={t(
              //               "createAsset.placeholders.countryExplanation"
              //             )}
              //           />
              //         </div>
              //       </div>
              //     </div>

              //     {/* Delivery Address Section */}
              //     <div className="mb-2">
              //       <div className="flex items-center gap-2   ">
              //         <div>
              //           {" "}
              //           <h5 className="text-sm font-medium mb-2 text-gray-600">
              //             {t("createAsset.placeholders.deliveryAddress")}
              //           </h5>
              //           <label className="flex items-center">
              //             <input
              //               type="checkbox"
              //               name="use_invoice_as_delivery"
              //               checked={newAsset.use_invoice_as_delivery}
              //               onChange={handleChange}
              //               className="mr-2"
              //             />
              //             <span className="text-sm text-gray-700">
              //               {t("createAsset.placeholders.sameAsInvoice")}
              //             </span>
              //           </label>
              //         </div>
              //         {/* <div className="">
              //         <InputField
              //           name="upload_financial_contract"
              //           type="file"
              //           onChange={handleChange}
              //           label="Upload_media"
              //           explanation="Upload asset media file"
              //           multiple
              //         />
              //       </div> */}
              //       </div>

              //       {/* {!newAsset.use_invoice_as_delivery && (
              //       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-2">
              //         <div>
              //           <InputField
              //             name="delivery_address_street"
              //             type="text"
              //             maxLength={100}
              //             value={newAsset.delivery_address_street}
              //             onChange={handleChange}
              //             placeholder="Enter street address"
              //             label="Street"
              //             explanation="Delivery street address"
              //           />
              //         </div>
              //         <div>
              //           <InputField
              //             name="delivery_address_zip"
              //             type="text"
              //             maxLength={20}
              //             value={newAsset.delivery_address_zip}
              //             onChange={handleChange}
              //             placeholder="Enter ZIP code"
              //             label="Zip "
              //             explanation="Delivery ZIP"
              //           />
              //         </div>
              //         <div>
              //           <InputField
              //             name="delivery_address_city"
              //             type="text"
              //             maxLength={50}
              //             value={newAsset.delivery_address_city}
              //             onChange={handleChange}
              //             placeholder="Enter city"
              //             label="City "
              //             explanation="Delivery city"
              //           />
              //         </div>
              //         <div>
              //           <InputField
              //             name="delivery_address_country"
              //             type="text"
              //             maxLength={50}
              //             value={newAsset.delivery_address_country}
              //             onChange={handleChange}
              //             placeholder="Enter country"
              //             label="Country"
              //             explanation="Delivery country"
              //           />
              //         </div>
              //       </div>
              //     )} */}
              //     </div>
              //   </div>
              //   {/* History Log Section */}

              //   <ContractHistoryTable
              //     id={id}
              //     refreshContracts={refreshContracts}
              //   />

              //   {/* Calendar View Section */}
              // </div>
            )}
            {selectedCategory === "Attachments" && (
              <ContractInfoSection
                t={t}
                contractForm={contractForm}
                handleChange={handleContractChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
                id={id}
                refreshContracts={refreshContracts}
                transportUrl={transportUrl}
                isValidUrl={isValidUrl}
                normalizedTransportUrl={normalizedTransportUrl}
              />
            )}
            {selectedCategory === "Lift Masts" && (
              <ContractInfoSection
                t={t}
                contractForm={contractForm}
                handleChange={handleContractChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
                id={id}
                refreshContracts={refreshContracts}
                transportUrl={transportUrl}
                isValidUrl={isValidUrl}
                normalizedTransportUrl={normalizedTransportUrl}
              />
            )}
            {selectedCategory === "Work Platforms" && (
              <ContractInfoSection
                t={t}
                contractForm={contractForm}
                handleChange={handleContractChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
                id={id}
                refreshContracts={refreshContracts}
                transportUrl={transportUrl}
                isValidUrl={isValidUrl}
                normalizedTransportUrl={normalizedTransportUrl}
              />
            )}
            {selectedCategory === "Cleaning Equipment" && (
              <ContractInfoSection
                t={t}
                contractForm={contractForm}
                handleChange={handleContractChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
                id={id}
                refreshContracts={refreshContracts}
                transportUrl={transportUrl}
                isValidUrl={isValidUrl}
                normalizedTransportUrl={normalizedTransportUrl}
              />
            )}
            {selectedCategory === "Spare Parts" && (
              <ContractInfoSection
                t={t}
                contractForm={contractForm}
                handleChange={handleContractChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
                id={id}
                refreshContracts={refreshContracts}
                transportUrl={transportUrl}
                isValidUrl={isValidUrl}
                normalizedTransportUrl={normalizedTransportUrl}
              />
            )}
            {selectedCategory === "Construction Machinery" && (
              <ContractInfoSection
                t={t}
                contractForm={contractForm}
                handleChange={handleContractChange}
                warehouses={warehouses}
                selectedContractWarehouse={selectedContractWarehouse}
                handleWarehouseChange2={handleWarehouseChange2}
                checboxValue={checboxValue}
                handleCheckboxToggle={handleCheckboxToggle}
                id={id}
                refreshContracts={refreshContracts}
                transportUrl={transportUrl}
                isValidUrl={isValidUrl}
                normalizedTransportUrl={normalizedTransportUrl}
              />
            )}
          </>
        )}
        {currentStep === 3 && (
          <>
            {/* Finance Information form */}

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="finance_partner"
                  value={newAsset.finance_partner}
                  onChange={handleChange}
                  placeholder={t(
                    "createAsset.placeholder.enterFinancialPartner"
                  )}
                  label="Financial Partner"
                  explanation="Enter the financial partner's name"
                  maxLength={150}
                  disabled={!isEditing}
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="financial_contract_classification"
                  value={newAsset.financial_contract_classification}
                  onChange={handleChange}
                  label="Financial Contract Classification"
                  explanation="Enter the classification of the financial contract"
                  placeholder={t(
                    "createAsset.placeholder.enterFinancialContractClassification"
                  )}
                  maxLength={150}
                  disabled={!isEditing}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="financial_contract"
                  value={newAsset.financial_contract}
                  onChange={handleChange}
                  placeholder={t(
                    "createAsset.placeholder.enterFinancialContract"
                  )}
                  label="Financial Contract"
                  explanation="Enter the financial contract details"
                  maxLength={150}
                  disabled={!isEditing}
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="financial_contract_no"
                  value={newAsset.financial_contract_no}
                  onChange={handleChange}
                  label="Financial Contract No"
                  explanation="Enter the financial contract number"
                  placeholder={t(
                    "createAsset.placeholder.enterFinancialContractNo"
                  )}
                  maxLength={150}
                  disabled={!isEditing}
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="upload_financial_contract"
                  type="file"
                  onChange={handleChange}
                  label="Upload Financial Contract"
                  explanation="Upload the financial contract file"
                  disabled={!isEditing}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="financial_contract_start"
                  type="date"
                  disabled={!isEditing}
                  onChange={handleChange}
                  label="Financial Contract Start"
                  explanation="Select the start date of the financial contract"
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="financial_contract_end"
                  type="date"
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Financial Contract End"
                  explanation="Select the end date of the financial contract"
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="duration_in_months"
                  type="number"
                  value={newAsset.duration_in_months}
                  disabled={!isEditing}
                  onChange={handleChange}
                  label="Duration in Months"
                  explanation="Enter the duration of the contract in months"
                  placeholder={t(
                    "createAsset.placeholder.enterDurationInMonths"
                  )}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="purchase_price"
                  type="number"
                  value={newAsset.purchase_price}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Purchase Price"
                  explanation="Enter the purchase price of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="acquisition_date"
                  type="date"
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Acquisition Date"
                  explanation="Select the acquisition date of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="residual_value_end_of_contract"
                  type="number"
                  value={newAsset.residual_value_end_of_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Residual Value End of Contract"
                  explanation="Enter the residual value at the end of the contract"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="book_value"
                  value={newAsset.book_value}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder={t("createAsset.placeholder.enterBookValue")}
                  label="Book Value"
                  explanation="Enter the book value of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="depreciation_value"
                  type="number"
                  value={newAsset.depreciation_value}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Depreciation Value"
                  explanation="Enter the depreciation value of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="acquisition_costs"
                  type="number"
                  value={newAsset.acquisition_costs}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Acquisition Costs"
                  explanation="Enter the acquisition costs of the asset"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <SelectField
                  name="depreciation_method"
                  value={newAsset.depreciation_method}
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Depreciation Method"
                  explanation="Select the method of depreciation"
                  menus={[
                    { value: "", option: "Select Depreciation Method" },
                    { value: "Linear 96 Months", option: "Linear 96 Months" },
                    {
                      value: "0.3% every 12 Months",
                      option: "0.3% every 12 Months",
                    },
                  ]}
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="next_depreciation"
                  type="date"
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Next Depreciation Date"
                  explanation="Select the next depreciation date"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="cost_refurbishing"
                  type="number"
                  value={newAsset.cost_refurbishing}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Cost of Refurbishing"
                  explanation="Enter the cost of refurbishing the asset"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="transportation_cost"
                  type="number"
                  value={newAsset.transportation_cost}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Transportation Cost"
                  explanation="Enter the transportation cost of the asset"
                />
              </div>
              {/* <div className="col-md-4">
             <InputField
                name="customer_name"
                type="text"
                maxLength={150}
                value={newAsset.customer_name}
                onChange={handleChange}
                disabled={!isEditing}
                placeholder="Enter the customer name"
                label="Customer name" 
                explanation="Enter the customer name"
              />
          </div> */}
              <div className="col-md-4">
                <InputField
                  name="customer_no"
                  type="number"
                  maxLength={50}
                  value={newAsset.customer_no}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Enter the customer no."
                  label="Customer no"
                  explanation="Enter the customer no."
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="customer_contract"
                  type="text"
                  maxLength={100}
                  value={newAsset.customer_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Enter the customer contract"
                  label="Customer contract"
                  explanation="Enter the customer contract"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="upload_customer_contract"
                  type="file"
                  disabled={!isEditing}
                  value={newAsset.upload_customer_contract}
                  onChange={handleChange}
                  placeholder="Upload customer contract"
                  label="Upload customer contract"
                  explanation="Upload customer contract"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="upload_customer_contract"
                  type="file"
                  disabled={!isEditing}
                  value={newAsset.upload_customer_contract}
                  onChange={handleChange}
                  placeholder="Upload customer contract"
                  label="Upload customer contract"
                  explanation="Upload customer contract"
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="end_of_contract"
                  type="date"
                  value={newAsset.end_of_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Enter end of contract"
                  label="Enter end of contract"
                  explanation="End of contract"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="financial_contract"
                  value={newAsset.financial_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder={t(
                    "createAsset.placeholder.enterFinancialContract"
                  )}
                  label="Financial Contract"
                  explanation="Enter the financial contract details"
                  maxLength={150}
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="financial_contract_no"
                  value={newAsset.financial_contract_no}
                  onChange={handleChange}
                  label="Financial Contract No"
                  disabled={!isEditing}
                  explanation="Enter the financial contract number"
                  placeholder={t(
                    "createAsset.placeholder.enterFinancialContractNo"
                  )}
                  maxLength={150}
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="upload_financial_contract"
                  type="file"
                  disabled={!isEditing}
                  onChange={handleChange}
                  label="Upload Financial Contract"
                  explanation="Upload the financial contract file"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="financial_contract_start"
                  type="date"
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Financial Contract Start"
                  explanation="Select the start date of the financial contract"
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="financial_contract_end"
                  type="date"
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Financial Contract End"
                  explanation="Select the end date of the financial contract"
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="duration_in_months"
                  type="number"
                  value={newAsset.duration_in_months}
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Duration in Months"
                  explanation="Enter the duration of the contract in months"
                  placeholder={t(
                    "createAsset.placeholder.enterDurationInMonths"
                  )}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="purchase_price"
                  type="number"
                  value={newAsset.purchase_price}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Purchase Price"
                  explanation="Enter the purchase price of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="acquisition_date"
                  type="date"
                  disabled={!isEditing}
                  onChange={handleChange}
                  label="Acquisition Date"
                  explanation="Select the acquisition date of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="residual_value_end_of_contract"
                  type="number"
                  value={newAsset.residual_value_end_of_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Residual Value End of Contract"
                  explanation="Enter the residual value at the end of the contract"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="book_value"
                  value={newAsset.book_value}
                  disabled={!isEditing}
                  onChange={handleChange}
                  placeholder={t("createAsset.placeholder.enterBookValue")}
                  label="Book Value"
                  explanation="Enter the book value of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="depreciation_value"
                  type="number"
                  disabled={!isEditing}
                  value={newAsset.depreciation_value}
                  onChange={handleChange}
                  placeholder="0"
                  label="Depreciation Value"
                  explanation="Enter the depreciation value of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="acquisition_costs"
                  type="number"
                  disabled={!isEditing}
                  value={newAsset.acquisition_costs}
                  onChange={handleChange}
                  placeholder="0"
                  label="Acquisition Costs"
                  explanation="Enter the acquisition costs of the asset"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <SelectField
                  name="depreciation_method"
                  disabled={!isEditing}
                  value={newAsset.depreciation_method}
                  onChange={handleChange}
                  label="Depreciation Method"
                  explanation="Select the method of depreciation"
                  menus={[
                    { value: "", option: "Select Depreciation Method" },
                    { value: "Linear 96 Months", option: "Linear 96 Months" },
                    {
                      value: "0.3% every 12 Months",
                      option: "0.3% every 12 Months",
                    },
                  ]}
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="next_depreciation"
                  type="date"
                  onChange={handleChange}
                  disabled={!isEditing}
                  label="Next Depreciation Date"
                  explanation="Select the next depreciation date"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="cost_refurbishing"
                  type="number"
                  value={newAsset.cost_refurbishing}
                  onChange={handleChange}
                  placeholder="0"
                  disabled={!isEditing}
                  label="Cost of Refurbishing"
                  explanation="Enter the cost of refurbishing the asset"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="transportation_cost"
                  type="number"
                  value={newAsset.transportation_cost}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="0"
                  label="Transportation Cost"
                  explanation="Enter the transportation cost of the asset"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="customer_name"
                  type="text"
                  maxLength={150}
                  value={newAsset.customer_name}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Enter the customer name"
                  label="Customer name"
                  explanation="Enter the customer name"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="customer_no"
                  type="number"
                  maxLength={50}
                  value={newAsset.customer_no}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Enter the customer no."
                  label="Customer no"
                  explanation="Enter the customer no."
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <InputField
                  name="customer_contract"
                  type="text"
                  maxLength={100}
                  disabled={!isEditing}
                  value={newAsset.customer_contract}
                  onChange={handleChange}
                  placeholder="Enter the customer contract"
                  label="Customer contract"
                  explanation="Enter the customer contract"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="upload_customer_contract"
                  type="file"
                  value={newAsset.upload_customer_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Upload customer contract"
                  label="Upload customer contract"
                  explanation="Upload customer contract"
                />
              </div>
              <div className="col-md-4">
                <InputField
                  name="upload_customer_contract"
                  type="file"
                  value={newAsset.upload_customer_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Upload customer contract"
                  label="Upload customer contract"
                  explanation="Upload customer contract"
                />
              </div>

              <div className="col-md-4">
                <InputField
                  name="end_of_contract"
                  type="date"
                  value={newAsset.end_of_contract}
                  onChange={handleChange}
                  disabled={!isEditing}
                  placeholder="Enter end of contract"
                  label="Enter end of contract"
                  explanation="End of contract"
                />
              </div>
            </div>
          </>
        )}
        <div className="flex flex-wrap gap-2 sm:gap-3 justify-center sm:justify-start items-center my-3">
          {currentStep < steps.length - 1 && (
            <>
              {/* {
                  !isEditing ? <button type = "submit" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto" variant="primary" >
                  Edit
                </button> : ""
                } */}

              {currentStep !== 0 ? (
                <button
                  variant="primary"
                  onClick={() => navigate("/dashboard")}
                  // disabled={currentStep === 0}
                  type="button"
                  className="bg-gray-200 text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
                >
                  {t("common.cancel")}
                </button>
              ) : (
                <button
                  type="button"
                  className="bg-gray-200 text-black px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
                  variant="close"
                  onClick={() => navigate("/dashboard")}
                >
                  {t("warehouse.cancelButton")}
                </button>
              )}
              {/* <button
                variant="primary"
                onClick={handlePreviousStep}
                disabled={currentStep === 0}
                type="button"
                
              > 
              </button> */}
              <button
                type="submit"
                className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isLoading}
              >
                {t("common.buttons.save")}
              </button>
            </>
          )}
          {currentStep === 2 && (
            <>
              <button
                className="bg-gray-200 text-black   px-4 py-2 -md text-sm sm:text-base w-full sm:w-auto"
                variant="primary"
                type="button"
                onClick={() => navigate("/dashboard")}
              >
                {t("common.cancel")}
              </button>
              {isEditing ? (
                <button
                  className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                    isLoading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={isLoading}
                  variant="primary"
                  type="button"
                  onClick={() => {
                    console.log("create contract ......");
                    console.log("contract form = ", contractForm);
                    handleCreateContract();
                  }}
                >
                  {t("common.buttons.save")}
                </button>
              ) : (
                ""
              )}
              {!isEditing ? (
                <button
                  type="button"
                  className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2  text-sm sm:text-base w-full sm:w-auto ${
                    isLoading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={isLoading}
                  variant="primary"
                  onClick={() => {
                    console.log("create contract ......");
                    console.log("contract form = ", contractForm);
                    handleCreateContract();
                  }}
                >
                  {t("common.buttons.save")}
                </button>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default EditAssetPageNew;
